window.CQR_DATA={"smart": {"handle": "smart-whole-house-water-filter", "title": "SMART Whole House Water Filter (9-13 GPM)", "img": "//cdn.shopify.com/s/files/1/1286/9985/products/standalone-fiberglass-1-000-000-gallons-smart-whole-house-water-filter-crystal-quest-whole-house-water-filters-2517756969074.jpg?v=1756491777", "variant_id": 41014801006685, "variant_title": "Standalone / Fiberglass / 1.5", "price": 179100, "compare": null, "nvar": 12, "img_full": "https://cdn.shopify.com/s/files/1/1286/9985/products/standalone-fiberglass-1-000-000-gallons-smart-whole-house-water-filter-crystal-quest-whole-house-water-filters-2517756969074.jpg?v=1756491777"}, "ro": {"handle": "whole-house-reverse-osmosis-system", "title": "Whole House Reverse Osmosis System", "img": "//cdn.shopify.com/s/files/1/1286/9985/products/2500-gpd-standalone-whole-house-reverse-osmosis-system-crystal-quest-reverse-osmosis-system-32662647996509.jpg?v=1756491768", "variant_id": 8656893542514, "variant_title": "4000 GPD / Standalone / 1.5 HP Horizontal Pump", "price": 640900, "compare": null, "nvar": 76, "img_full": "https://cdn.shopify.com/s/files/1/1286/9985/products/2500-gpd-standalone-whole-house-reverse-osmosis-system-crystal-quest-reverse-osmosis-system-32662647996509.jpg?v=1756491768"}, "pou": {"handle": "reverse-osmosis-under-sink-water-filter", "title": "Thunder Ultrafiltration/Reverse Osmosis Under Sink Water Filter | 1000CP | 12 Stages of Filtration", "img": "//cdn.shopify.com/s/files/1/1286/9985/files/thunder-ultrafiltration-reverse-osmosis-under-sink-water-filter-1000cp-12-stages-of-filtration-crystal-quest-reverse-osmosis-system-33510697140317.jpg?v=1695662146", "variant_id": 23924497799, "variant_title": "Default Title", "price": 47816, "compare": null, "nvar": 1, "img_full": "https://cdn.shopify.com/s/files/1/1286/9985/files/thunder-ultrafiltration-reverse-osmosis-under-sink-water-filter-1000cp-12-stages-of-filtration-crystal-quest-reverse-osmosis-system-33510697140317.jpg?v=1695662146"}, "uv": {"handle": "12-gpm-uv-water-sterilizer-optional", "title": "12 GPM UV Water Sterilizer (Optional)", "img": null, "variant_id": 41593353306205, "variant_title": "checked", "price": 56900, "compare": null, "nvar": 1, "img_full": ""}, "cond": {"handle": "salt-free-water-conditioner", "title": "Salt-Free Water Conditioner", "img": "//cdn.shopify.com/s/files/1/1286/9985/files/1-5-fiberglass-salt-free-water-conditioner-crystal-quest-whole-house-water-filters-33868266897501.jpg?v=1756491832", "variant_id": 22497994503, "variant_title": "Standalone / Fiberglass / 1.5", "price": 214700, "compare": null, "nvar": 4, "img_full": "https://cdn.shopify.com/s/files/1/1286/9985/files/1-5-fiberglass-salt-free-water-conditioner-crystal-quest-whole-house-water-filters-33868266897501.jpg?v=1756491832"}, "_saving": {"separate": 3938, "combined": 3630, "delta": 308}, "iron": {"handle": "iron-whole-house-water-filter", "title": "Metal Removal Whole House Water Filter", "img_full": "https://cdn.shopify.com/s/files/1/1286/9985/products/standalone-fiberglass-1-5-iron-whole-house-water-filter-crystal-quest-whole-house-water-filters-28702017912925.jpg?v=1756491794", "variant_id": 41014796681309, "variant_title": "Standalone / Fiberglass / 1.5", "price": 133100, "compare": null, "nvar": 16}};
;

(function(){
"use strict";
var P = window.CQR_DATA || {};
var money = function(c){ return c==null?"":"$"+(c/100).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2}); };
var esc = function(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); };
var num = function(s){ var n=parseInt(String(s==null?"":s).replace(/,/g,""),10); return isNaN(n)?0:n; };
var DATA_VER="66";
function assetUrl(u){
  /* Shopify deployment: the hosting section maps our relative data/vendor
     paths to CDN asset urls via window.CQW_ASSETS; local dev passes through */
  try{ if(window.CQW_ASSETS && window.CQW_ASSETS[u]) return window.CQW_ASSETS[u]; }catch(e){}
  return u;
}
function getJSON(u){ var m=assetUrl(u); return fetch(m + (m.indexOf("?")<0?"?v="+DATA_VER:"")).then(function(r){ if(!r.ok) throw new Error(u); return r.json(); }); }
function cqTrack(ev, props){
  /* privacy-safe funnel events: no water specifics, no contact data */
  try{
    var row = { event: "cqw_"+ev };
    for (var k in (props||{})) row[k]=props[k];
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(row);
  }catch(err){}
}
var cache = { zipIndex:null, fb:null, aliases:null, registry:null, prices:{} };
getJSON("data/quiz_registry.json").then(function(r){ cache.registry=r; }).catch(function(){});
function regRow(h){ return (cache.registry && cache.registry.products && cache.registry.products[h]) || null; }
function fetchPrice(h){
  if(cache.prices[h]) return Promise.resolve(cache.prices[h]);
  return fetch(PROD_BASE+"/products/"+h+".js")
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(pr){
      var vs=(pr.variants||[]).filter(function(v){ return v.available!==false; });
      var min=null; (vs.length?vs:pr.variants||[]).forEach(function(v){ if(min===null||v.price<min) min=v.price; });
      var rec={ price:(min!==null?min:pr.price), n:(pr.variants||[]).length,
                variants:(vs.length?vs:pr.variants||[]).map(function(v){ return {id:v.id, title:String(v.title||""), price:v.price}; }) };
      cache.prices[h]=rec; return rec;
    });
}
/* ---- exact-variant resolution (AJ 2026-08-03): when the recommendation
   pins an axis (tank size, GPM, dosing chemical), price and link THAT
   variant instead of the cheapest one. A hint only applies when some
   variant title actually carries that axis; the price is only shown as
   exact when a single variant survives every applicable hint. ---- */
function variantHints(h, cfgKind){
  /* each hint: {rx, neg} - applied only if some variant title matches rx.
     Titles vary per product (live-verified 2026-08-03: axis names and value
     wording are inconsistent across handles), so hints self-activate. */
  var hints=[];
  if(h==="dosing-system"){ hints.push({rx:/chlorine/i}); hints.push({rx:/110/}); }
  if(h==="high-flow-whole-house-water-filter"){
    /* AJ 2026-08-03: HF combined configurations resolve on the HF product
       itself - pin the media Type from the engine's pick and the base 15
       GPM tier (higher tiers stay one click away on the preselected page) */
    hints.push({rx:new RegExp(LAST.hfType==="eagle"?"eagle":"smart","i")});
    /* opus verify D2: the tier comes from the DISPLAYED label (15/20/35 GPM
       all real); 20 GPM only when no label names one (4+ baths per the page) */
    var hfT=String(LAST.sizeLine||"").match(/High Flow, (\d+) GPM/);
    hints.push({rx:new RegExp("\\b"+(hfT?hfT[1]:"20")+"\\s*GPM","i")});
  }
  if(h==="big-blue-whole-house-water-filter-eagle-series"){
    /* RO remineralization add-on: Single cartridge, 1 inch line, no stand */
    hints.push({rx:/single/i}); hints.push({rx:/1" \/ without/i});
  }
  if(h==="lead-removal-whole-house-water-filter"){
    /* lead unit sizes by GPM flow, not cu ft (live axis) - map the home */
    var lsz=String(LAST.sizeLine||"");
    var lg = /^1\.5 cu ft/.test(lsz) ? "6-8" : /^2\.0 cu ft/.test(lsz) ? "8-10" : /High Flow/.test(lsz) ? "16-18" : null;
    if(lg) hints.push({rx:new RegExp("^"+lg+"\\s*GPM","i")});
  }
  if(h==="whole-house-reverse-osmosis-system"){
    /* exact GPD + storage from the engine's sizing; Brass Rotary is the
       standard pump (the 4000 GPD tier only ships with the 1.5 HP, where
       the brass hint self-deactivates) */
    var rz=String(LAST.roSize||"").match(/^(\d+) GPD \+ (\d+) gal/);
    if(rz){
      hints.push({rx:new RegExp("^"+rz[1]+"\\s*GPD","i")});
      hints.push({rx:new RegExp("\\("+rz[2]+" Gal\\)","i")});
      hints.push({rx:/brass/i});
    }
  }
  if(cfgKind==="conditioner") hints.push({rx:/salt.?free|anti.?scale/i});
  /* the neg excludes only the specialty "With SMART Filter and Softener"
     wording, never the bare SMART media type (opus verify D3: High Flow
     titles end "/ SMART" and were wrongly excluded) */
  else if(cfgKind==="softener") hints.push({rx:/with (water )?softener/i, neg:/smart filter/i});
  else hints.push({rx:/standalone/i});
  /* Fiberglass is the standard structure (the price every card advertises);
     stainless stays a product-page upgrade; 110V is the US-standard voltage
     default - both self-activate only when the product carries that axis */
  hints.push({rx:/fiberglass/i});
  hints.push({rx:/\b110/});
  var sz=String(LAST.sizeLine||"");
  var hf=sz.match(/High Flow, (\d+) GPM/);
  if(hf) hints.push({rx:new RegExp(hf[1]+"\\s*GPM","i")});
  else if(/^1\.5 cu ft/.test(sz)) hints.push({rx:/1\.5/});
  else if(/^2\.0 cu ft/.test(sz)) hints.push({rx:/(?:^|\/)\s*2(?:\.0)?(?!\d)/i});
  return hints;
}
/* ---- one-click build cart (AJ 2026-08-03): live ONLY on crystalquest.com
   (same-origin AJAX; cart permalinks are banned - they skip UpCart). The
   button self-hides unless EVERY stage resolves to an exact variant id. ---- */
var CART_HOST = /^(www\.)?crystalquest\.com$/i.test(location.hostname);
var PROD_BASE = CART_HOST ? "" : "https://crystalquest.com";
/* body scroll lock: remembers and restores whatever was there before, and a
   pagehide failsafe means the theme can never be left scroll-locked */
var BODY_PREV_OVERFLOW=null;
function lockBody(){ if(BODY_PREV_OVERFLOW===null) BODY_PREV_OVERFLOW=document.body.style.overflow||""; document.body.style.overflow="hidden"; }
function unlockBody(){ document.body.style.overflow=(BODY_PREV_OVERFLOW!==null?BODY_PREV_OVERFLOW:""); BODY_PREV_OVERFLOW=null; }
window.addEventListener("pagehide", unlockBody);
var CART_BUSY=false, CART_ADDED_SIG=null;
function cartSig(items){ return items.map(function(x){ return x.id; }).sort().join(","); }
function stageOff(h){ return !!(LAST.off && LAST.off[h]); }
function stageAdded(h){ return !!(LAST.added && LAST.added[h]); }
function toggleAdd(h){
  LAST.added = LAST.added || {};
  LAST.added[h] = !LAST.added[h];
  var on = LAST.added[h];
  /* opus verify D4: cond chips are .cqr-stage2--maybe, not --addable -
     mark ANY chip for this handle */
  var chips=document.querySelectorAll('.cqr-stage2[data-stage="'+h+'"]');
  for(var i=0;i<chips.length;i++) chips[i].classList.toggle("is-added", on);
  cqTrack("build_add",{handle:h, on:on?1:0});
  paintPrices();
}
function buildCartItems(){
  var hs=LAST.setupHandles||[];
  if(!hs.length) return null;
  var items=[];
  for(var i=0;i<hs.length;i++){
    var h=hs[i];
    if(stageOff(h)) continue; /* removed in the on-screen build editor */
    if(LAST.cfg && h===LAST.cfg.anchor) continue; /* added via the combined variant below */
    var r=resolveVariant(h);
    if(!r || !r.id) return null;
    items.push({id:r.id, quantity:1});
  }
  if(LAST.cfg && !stageOff(LAST.cfg.fallback)){
    var rc=resolveVariant(LAST.cfg.anchor, LAST.cfg.kind);
    if(rc && rc.cfgMatched && rc.id){ items.push({id:rc.id, quantity:1}); }
    else {
      var ra=resolveVariant(LAST.cfg.anchor), rf=resolveVariant(LAST.cfg.fallback);
      if(!ra || !ra.id || !rf || !rf.id) return null;
      items.push({id:ra.id, quantity:1}); items.push({id:rf.id, quantity:1});
    }
  } else if(LAST.cfg){
    /* configuration removed: the anchor rides standalone */
    var ra2=resolveVariant(LAST.cfg.anchor);
    if(!ra2 || !ra2.id) return null;
    items.push({id:ra2.id, quantity:1});
  }
  /* optional additions the customer switched on */
  var adds=LAST.addable||[];
  for(var a2=0;a2<adds.length;a2++){
    var ah=adds[a2].handle;
    if(!stageAdded(ah)) continue;
    var ar=resolveVariant(ah);
    if(!ar || !ar.id) return null;
    items.push({id:ar.id, quantity:1});
  }
  return items.length ? items : null;
}
/* ---- on-screen build editor + system drawer (AJ 2026-08-03): read about
   any stage, remove or restore it, and the total + cart follow - no hop to
   product pages required (the full page stays one optional link away) ---- */
function toggleStage(h){
  LAST.off = LAST.off || {};
  LAST.off[h] = !LAST.off[h];
  var off = LAST.off[h];
  var chips=document.querySelectorAll('.cqr-stage2[data-stage="'+h+'"]');
  for(var i=0;i<chips.length;i++) chips[i].classList.toggle("cqr-stage2--off", off);
  var xs=document.querySelectorAll('[data-chipx="'+h+'"]');
  for(var k=0;k<xs.length;k++){
    xs[k].innerHTML = off ? "+" : "&#215;";
    xs[k].setAttribute("title", off ? "Add back to build" : "Remove from build");
    xs[k].setAttribute("aria-label", (off ? "Add " : "Remove ")+h+(off ? " back to this build" : " from this build"));
  }
  cqTrack("build_edit",{handle:h, off:off?1:0});
  paintPrices(); /* cached: instant re-total + cart-button refresh */
}
function upkeepFor(h){
  /* canon service-life table (product-truth.md) - never invented numbers */
  if(/reverse-osmosis-under-sink/.test(h)) return "Membrane every 2 to 4 years; pre-filters every 12 to 24 months.";
  if(h==="whole-house-reverse-osmosis-system") return "Membrane every 2 to 4 years; pre and post filters every 12 to 24 months.";
  if(/ultraviolet/.test(h)) return "Replace the UV lamp about once a year.";
  if(/dosing-system/.test(h)) return "Refill the dosing solution as it is used; no media bed to replace.";
  if(/big-blue|slimline|compact/.test(h)) return "Cartridge swap every 12 to 24 months.";
  if(/water-softener/.test(h)) return "Keep salt topped up; the resin bed lasts 10 to 15 years.";
  if(/salt-free/.test(h)) return "Conditioning media lasts 5 to 7 years depending on hardness, iron, chlorine and usage.";
  if(/under-sink|countertop/.test(h)) return "Cartridges every 12 to 24 months.";
  if(/whole-house|high-flow|guardian/.test(h)) return "Main media bed lasts 5 to 7 years (1.5 cu ft) or 7 to 10 years (2.0).";
  return "";
}
function closeDrawer(){
  var d=document.getElementById("cqr-drawer"), v=document.getElementById("cqr-dveil");
  if(d) d.hidden=true; if(v) v.hidden=true;
  try{ if(d && d._opener && d._opener.focus){ d._opener.focus(); d._opener=null; } }catch(e){}
}
function openDrawer(h){
  var info=(LAST.stageInfo||{})[h]; if(!info) return;
  var d=document.getElementById("cqr-drawer"), v=document.getElementById("cqr-dveil");
  if(!d||!v) return;
  var priceHtml="Checking today&#39;s price&hellip;";
  if(info.cfg && LAST.cfg){
    var rc=resolveVariant(LAST.cfg.anchor, LAST.cfg.kind), ra=resolveVariant(LAST.cfg.anchor, null);
    if(rc && rc.cfgMatched && rc.exact && ra && ra.exact && rc.price>ra.price)
      priceHtml="+ "+money(rc.price-ra.price)+' <span class="cqr-pricecap">in the bundle ('+money(rc.price)+" total with your system)</span>";
    else priceHtml="bundled with your system";
  } else {
    var r=resolveVariant(h);
    if(r && r.price!=null) priceHtml=(r.exact?"":"from ")+money(r.price);
  }
  var off=stageOff(h);
  var inc = (info.anchor && LAST.res && LAST.res.includes && LAST.res.includes.length)
    ? '<div class="cqr-inc"><b>What is included</b><ul>'+LAST.res.includes.map(function(rw){
        return '<li>'+esc(rw.name)+(rw.optional?' <span class="cqr-inc-opt">optional add-on</span>':'')+'</li>';
      }).join("")+'</ul></div>' : "";
  /* the drawer speaks the exact card language: tier label, plate, name,
     price row, why list, card buttons (AJ 2026-08-03) */
  var act;
  if(info.cond){
    /* AJ 2026-08-03: test-first framing stays, but the purchase path is
       theirs to take - add-to-build first, the kit right beside it */
    act = (stageAdded(h)
      ? '<button class="cqr-btn cqr-btn--ghost" type="button" data-drawer-add="'+esc(h)+'">Remove from my build</button>'
      : '<button class="cqr-btn cqr-btn--solid" type="button" data-drawer-add="'+esc(h)+'">Add to my build</button>')+
      '<a class="cqr-btn cqr-btn--ghost" href="'+((info.kit&&info.kit.url)||"")+'" target="_blank" rel="noopener">Get the '+esc((info.kit&&info.kit.name)||"test kit")+'</a>';
  } else if(info.anchor){
    act = '';
  } else {
    act = '<button class="cqr-btn cqr-btn--ghost" type="button" data-drawer-toggle="'+esc(h)+'">'+(off?"Add back to this build":"Remove from this build")+'</button>';
  }
  d.innerHTML='<button class="cqr-drawer-close" type="button" aria-label="Close details">&#215;</button>'+
    '<p class="cqr-tierlabel">'+info.tag+(info.anchor?' &middot; your start-here system':'')+'</p>'+
    '<div class="cqr-plate">'+(info.img?'<img src="'+info.img+'" alt="'+esc(info.name)+'">':'')+'</div>'+
    '<h3 class="cqr-name">'+esc(info.name)+'</h3>'+
    '<div class="cqr-price"><span class="cqr-now" style="font-size:20px">'+priceHtml+'</span></div>'+
    '<ul class="cqr-why"><li>'+(info.why||"")+'</li></ul>'+
    (upkeepFor(h)?'<p class="cqr-good"><b>Ownership:</b> '+upkeepFor(h)+'</p>':'')+inc+
    '<div class="cqr-actions cqr-drawer-actions">'+act+
    '<a class="cqr-btn cqr-btn--solid" data-vh="'+esc(h)+'" href="'+info.url+'" target="_blank" rel="noopener">View full product page</a>'+
    '</div>';
  d._opener = document.activeElement;
  v.hidden=false; d.hidden=false;
  var cb=d.querySelector(".cqr-drawer-close"); if(cb) cb.focus();
  cqTrack("stage_drawer",{handle:h});
}
(function(){
  var v=document.createElement("div"); v.id="cqr-dveil"; v.className="cqr-drawer-veil"; v.hidden=true;
  var d=document.createElement("div"); d.id="cqr-drawer"; d.className="cqr-drawer"; d.hidden=true;
  d.setAttribute("role","dialog"); d.setAttribute("aria-modal","true"); d.setAttribute("aria-label","System details");
  document.body.appendChild(v); document.body.appendChild(d);
  v.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeDrawer(); });
})();
function addBuildToCart(btn){
  if(CART_BUSY) return; /* review fix: never two POSTs in flight */
  var items=buildCartItems();
  if(!items) return;
  /* quiz-sourced orders carry attribution for the reps */
  items=items.map(function(x){ return {id:x.id, quantity:x.quantity, properties:{_source:"water-wizard"}}; });
  CART_BUSY=true;
  btn.disabled=true; btn.textContent="Adding your build…";
  cqTrack("add_build_to_cart",{n:items.length});
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({items:items})})
    .then(function(r2){ if(!r2.ok) throw 0; return r2.json(); })
    .then(function(){
      CART_BUSY=false; CART_ADDED_SIG=cartSig(items);
      btn.textContent="Added ✓ open your cart";
      btn.disabled=false;
      btn.onclick=function(){ window.location.href="/cart"; };
      /* nudge the side cart to refresh/open via every hook the stack knows */
      try{ document.dispatchEvent(new CustomEvent("cart:item-add",{bubbles:true})); }catch(e){}
      try{ document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true})); }catch(e){}
      try{ if(window.upcartRefreshCart) window.upcartRefreshCart(); }catch(e){}
      try{ if(window.upcartOpenCart) window.upcartOpenCart(); }catch(e){}
    })
    .catch(function(){
      CART_BUSY=false;
      btn.disabled=false;
      btn.textContent="Could not add automatically, open the cart page";
      btn.onclick=function(){ window.location.href="/cart"; };
    });
}
/* card checkboxes drive the same build state as the band editor; every
   checkbox for the same handle stays in sync (AJ 2026-08-03) */
function syncChecks(h){
  var offState = !stageOff(h), addState = stageAdded(h);
  var els=document.querySelectorAll('[data-bcheck="'+h+'"]');
  for(var i=0;i<els.length;i++){
    els[i].checked = els[i].getAttribute("data-bkind")==="add" ? addState : offState;
  }
}
document.addEventListener("change",function(e){
  var cb=e.target && e.target.closest ? e.target.closest("[data-bcheck]") : null;
  if(!cb) return;
  var h=cb.getAttribute("data-bcheck");
  if(cb.getAttribute("data-bkind")==="add") toggleAdd(h); else toggleStage(h);
  syncChecks(h);
});
document.addEventListener("click",function(e){
  var t=e.target; if(!t || !t.closest) return;
  var x=t.closest("[data-chipx]");
  if(x){ e.preventDefault(); e.stopPropagation(); var xh=x.getAttribute("data-chipx"); toggleStage(xh); syncChecks(xh); return; }
  var ap=t.closest("[data-anchorpick]");
  if(ap){
    S.anchorPref=ap.getAttribute("data-anchorpick");
    cqTrack("anchor_pick",{handle:S.anchorPref});
    showResult();
    window.scrollTo(0,0);
    return;
  }
  var dt=t.closest("[data-drawer-toggle]");
  if(dt){ var th=dt.getAttribute("data-drawer-toggle"); toggleStage(th); syncChecks(th); openDrawer(th); return; }
  var da=t.closest("[data-drawer-add]");
  if(da){ var ha=da.getAttribute("data-drawer-add"); toggleAdd(ha); syncChecks(ha); openDrawer(ha); return; }
  var bm=t.closest("[data-bmode]");
  if(bm){
    var mv=bm.getAttribute("data-bmode")==="ro" ? "ro" : null;
    if(mv!==S.buildMode){
      var fromBand = !!bm.closest(".cqr-band");
      S.buildMode=mv;
      cqTrack("build_mode",{mode:mv||"media"});
      showResult();
      if(fromBand){
        var bd=document.getElementById("cqr-band");
        if(bd) window.scrollTo(0, Math.max(bd.offsetTop-70, 0));
      } else {
        window.scrollTo(0,0);
      }
    }
    return;
  }
  if(t.closest(".cqr-drawer-close")){ closeDrawer(); return; }
  var ch=t.closest('a.cqr-stage2[data-stage]');
  if(ch && !e.metaKey && !e.ctrlKey && !e.shiftKey){ e.preventDefault(); openDrawer(ch.getAttribute("data-stage")); return; }
  var ab=t.closest("#cqr-addbuild");
  if(ab && !ab.onclick) addBuildToCart(ab);
});
function resolveVariant(h, cfgKind){
  var rec=cache.prices[h];
  if(!rec) return null;
  var vs=rec.variants||[];
  if(!vs.length) return {price:rec.price, n:rec.n, id:null, exact:rec.n<=1, cfgMatched:false};
  var pool=vs, cfgMatched=false;
  variantHints(h, cfgKind).forEach(function(hint){
    var m=pool.filter(function(v){ return hint.rx.test(v.title) && !(hint.neg && hint.neg.test(v.title)); });
    if(m.length){
      pool=m;
      if(cfgKind && (hint.rx.source.indexOf("salt")>-1 || hint.rx.source.indexOf("softener")>-1)) cfgMatched=true;
    }
  });
  if(pool.length===1) return {price:pool[0].price, n:rec.n, id:pool[0].id, exact:true, cfgMatched:cfgMatched};
  var min=null; pool.forEach(function(v){ if(min===null||v.price<min) min=v.price; });
  return {price:(min!==null?min:rec.price), n:pool.length, id:null, exact:pool.length<=1, cfgMatched:cfgMatched};
}
var zipSeq = 0; // guards against stale async ZIP lookups overwriting newer state

/* ---- question definitions ---- */
var QS = [
 {k:"scope", label:"What to improve", q:"What water do you want to improve?", hint:"Takes about a minute. Every answer shapes a system designed around your home, not a one-size-fits-all box.", multi:false, cols:1, opts:[
   {v:"pou",n:"Water we drink and cook with",s:"Kitchen tap, coffee, ice, and recipes"},
   {v:"whole",n:"Water throughout the home",s:"Drinking, showers, laundry, and appliances"},
   {v:"unsure",n:"Help me decide",s:"Show me both ways after checking my water"}]},
 {k:"source", label:"Water source", q:"Where does your home's water come from?", hint:"City and well water live different lives. If you're not sure, a water bill means city.", multi:false, cols:1, opts:[
   {v:"city",n:"City / municipal",s:"I receive a water bill"},
   {v:"well",n:"Private well",s:"My water comes from a private source"},
   {v:"unsure",n:"Not sure",s:"We'll work it out from your answers and tell you what we assumed"}]},
 {k:"notice", label:"What you notice", q:"What have you noticed about your water?", hint:"Trust your senses, they catch what lab reports miss between tests. Tick anything familiar.", multi:true, cols:2, opts:[
   {v:"chlorine",n:"Smells or tastes like a pool",s:"Strongest first thing in the morning, or from the hot tap"},
   {v:"egg",n:"Rotten-egg or sulfur smell",s:"Often worse on the hot side, or after the house sits unused"},
   {v:"orange",n:"Orange or rust-colored marks",s:"Rings in sinks and tubs, streaks on laundry, tinted water after a while"},
   {v:"scale",n:"Chalky white spots and crust",s:"Cloudy film on glassware, crust on taps and the kettle, skin feels dry"},
   {v:"blue",n:"Blue or blue-green staining",s:"A turquoise tinge where water sits, around drains and fittings"},
   {v:"cloudy",n:"Cloudy, gritty or sandy",s:"Water that will not settle clear, or grit collecting in aerators"},
   {v:"tint",n:"Yellow or tea-colored tint",s:"Looks faintly brewed, most obvious in a white tub or basin"},
   {v:"salty",n:"Salty or brackish taste",s:"A faint saltiness, or the water just tastes heavy"},
   {v:"metallic",n:"Metallic or coppery taste",s:"Like licking a coin, sometimes with a bitter edge"},
   {v:"none",n:"Nothing I can point to",s:"It seems fine, but plenty of things have no taste or smell"}]},
 {k:"surround", geo:true, label:"Around your home", q:"What's around your well?", hint:"A well drinks from the land around it. Tick anything nearby and we'll factor in the usual suspects.", multi:true, cols:2, opts:[
   {v:"farm",n:"Farms or cropland",s:"Fertilizer and livestock can reach groundwater as nitrate"},
   {v:"woods",n:"Wooded, marshy or pond-fed land",s:"Decaying leaves tint well water yellow-brown"},
   {v:"septic",n:"A septic system on or near the property",s:"Yours or a neighbor's, especially uphill of the well"},
   {v:"fuel",n:"A gas station or dry cleaner nearby",s:"Fuel and solvent compounds travel in groundwater"},
   {v:"cemetery",n:"An older cemetery uphill",s:"Legacy arsenic compounds from the embalming era"},
   {v:"industry",n:"Industry, an airport or a military base",s:"PFAS firefighting foam use at bases, training grounds and airfields"},
   {v:"oldhome",n:"The home was built before 1990",s:"Older plumbing can add lead at the tap from solder and fittings"},
   {v:"bedrock",n:"Rocky or mountain area (granite bedrock)",s:"This kind of ground can send radon and uranium into well water"},
   {v:"volcanic",n:"Volcanic rock area (Pacific Northwest, Hawaii)",s:"Volcanic ground sheds silica, a scale-former softeners cannot remove"},
   {v:"none",n:"None of these",s:"Open land, no obvious neighbors"}],
   wellsub:{title:"Is the well chlorinated?", items:[
   {v:"yes",n:"Yes, a chlorinator runs on it",s:"Continuous chlorine injection"},
   {v:"shock",n:"We shock it now and then",s:"Occasional shock chlorination"},
   {v:"no",n:"No, or not sure",s:"No treatment we know of"}]}},
 {k:"concerns", label:"Specific worries", q:"Any specific worries?", hint:"From the news, a neighbor's test, or your area's history. Skip if none.", multi:true, cols:2, opts:[
   {v:"lead",n:"Lead",s:"Heard about it locally, or the house is older"},
   {v:"pfas",n:"PFAS (forever chemicals)",s:"Nonstick and waterproofing chemicals found in many water systems"},
   {v:"arsenic",n:"Arsenic",s:"A neighbor tested for it, or it is known in local wells"},
   {v:"nitrate",n:"Nitrate",s:"Common where there is farming or septic nearby"},
   {v:"bacteria",n:"Bacteria",s:"The well has never been tested, or something changed recently"},
   {v:"iron",n:"Iron",s:"Staining, or a metallic taste you keep noticing"},
   {v:"fluoride",n:"Fluoride",s:"You want it out of your water"},
   {v:"hardness",n:"Hard water",s:"Scale, spots, dry skin, or a softener question"}],
   more:[
   {v:"chromium6",n:"Chromium-6",s:"An industrial metal; a concern near factories and plating shops"},
   {v:"radon",n:"Radon",s:"Granite bedrock regions, or radon found in the air at home"},
   {v:"uranium",n:"Uranium / radium",s:"Natural radioactive metals from certain kinds of bedrock"},
   {v:"mercury",n:"Mercury",s:"Industrial or mining history in the area"},
   {v:"vocs",n:"Fuel or solvent chemicals (VOCs)",s:"Vapors from fuel and solvents that can seep into water"},
   {v:"sulfate",n:"Sulfate",s:"A mineral salt behind bitter taste and stomach upset in visitors"},
   {v:"microplastics",n:"Microplastics",s:"Plastic particles from pipes and packaging. Reverse osmosis is the surest reduction"}],
   sub:{title:"Two quick things about your home and area", items:[
   {v:"oldhome",n:"Built before 1990",s:"Older homes can add lead at the tap from solder and fittings"},
   {v:"industry",n:"Industry, an airport or a military base nearby",s:"PFAS firefighting foam use at bases, training grounds and airfields"}]}},
 {k:"sizing", kind:"sizing", label:"Size it right", q:"Last step: fit it to your home.", hint:"Right-sized means full pressure on busy mornings and years of quiet service. A few taps and we're done."}
];
function activeQS(){ return QS.filter(function(q){
  if(q.kind==="sizing" && S.scope==="pou") return false;
  /* geography shows for wells AND for "not sure" (Sol-converged 2026-07-29:
     the unsure route gets geography as its own slide, soft signals only) */
  if(q.geo && S.source!=="well" && S.source!=="unsure") return false;
  return true;
}); }

var S = {}, idx = 0;
QS.forEach(function(q){ if(q.kind) return; S[q.k] = q.multi?[]:null; });
S.surround=[]; S.people=null; S.baths=null; S.demand=[]; S.view=null; S.wellchlor=null; S.configPref=null; S.buildMode=null; S.anchorPref=null;
/* two tools, one engine: ?mode=report boots the Water Report Analyzer
   (report-first landing, same result pipeline); default is the Q&A wizard */
var BOOTQ = new URLSearchParams(location.search);
var MODE = BOOTQ.get("mode")==="report" ? "report" : "quiz";
/* companion prototype pages (hub/contaminant) exist only on local dev, not on /pages/ hosting */
var CQW_LOCAL_LINKS = location.pathname.indexOf("/pages/")!==0;
if(BOOTQ.get("src")==="well") S.source="well"; else if(BOOTQ.get("src")==="city") S.source="city";

var elSteps=document.getElementById("cqw-steps"), elSlides=document.getElementById("cqw-slides"),
    elCount=document.getElementById("cqw-count");

function findOpt(q,val){
  var all=q.opts.concat(q.more||[]);
  return all.filter(function(o){return o.v===val;})[0]||null;
}
function answerText(q){
  if(q.kind==="sizing"){
    var parts=[];
    if(S.people) parts.push(({"2":"1-2","4":"3-4","6":"5-6","8":"7+"})[S.people]+" people");
    if(S.baths) parts.push(S.baths+" baths");
    return parts.join(", ");
  }
  var v=S[q.k];
  if(q.multi){ if(!v.length) return "Skipped";
    return v.map(function(x){ var o=findOpt(q,x); return o?o.n:x; }).join(", "); }
  if(!v) return "";
  var o=findOpt(q,v); return o?o.n:v;
}

function syncFoot(){
  var b=document.getElementById("cqw-back"), n=document.getElementById("cqw-next");
  if(b) b.style.visibility = idx===0 ? "hidden" : "visible";
  if(n) n.textContent = (idx===activeQS().length-1) ? "See my recommendation" : "Continue";
}
function drawRail(){
  elSteps.innerHTML = activeQS().map(function(q,i){
    var cls = i===idx?"is-on":(i<idx?"is-done":"");
    var ans = i<idx?answerText(q):"";
    return '<li class="cqw-step '+cls+'"><span class="cqw-dot">'+(i<idx?"&#10003;":(i+1))+'</span>'+
      '<span class="cqw-stext"><span class="cqw-slabel">'+q.label+'</span>'+
      (ans?'<span class="cqw-sans">'+ans+'</span>':'')+'</span></li>';
  }).join("");
  elCount.textContent = "Question "+(idx+1)+" of "+activeQS().length;
  syncFoot();
}

/* source-aware option ordering (AJ spec): on a well lead with iron, sulphur, bacteria;
   on city with chlorine, hardness, PFAS, lead. Same options, same mapping, just reordered.
   "none" always stays last; unlisted options keep their relative order. */
var LEAD_ORDER = {
  notice:   { well:["orange","egg","metallic","cloudy","tint"], city:["chlorine","scale","cloudy","blue"] },
  concerns: { well:["bacteria","iron","arsenic","nitrate"],     city:["lead","pfas","nitrate","arsenic"] }
};
function orderedOpts(q){
  var lead=(LEAD_ORDER[q.k]||{})[S.source==="well"?"well":"city"];
  if(!lead) return q.opts;
  function rank(o){ if(o.v==="none") return 99; var i=lead.indexOf(o.v); return i<0?50:i; }
  return q.opts.slice().sort(function(a,b){ return rank(a)-rank(b); });
}

/* the old mid-flow well-records note was CUT (Sol-converged 2026-07-29, P7):
   it answered a question nobody asked at the highest-stakes screen, and the
   result page already carries the message twice (test-first band + refine card) */
function optBtn(q,i,o){
  var sel=q.multi?(S[q.k].indexOf(o.v)>-1):(S[q.k]===o.v);
  return '<button class="cqw-opt'+(sel?' is-sel':'')+'" type="button" aria-pressed="'+(sel?"true":"false")+'" data-q="'+i+'" data-v="'+o.v+'">'+
    '<span class="cqw-tick">&#10003;</span><span class="cqw-otext"><span class="cqw-oname">'+o.n+'</span>'+
    (o.s?'<span class="cqw-osub">'+o.s+'</span>':'')+'</span></button>';
}
function gBtn(g,o,sel){
  return '<button class="cqw-opt cqw-opt--sm'+(sel?' is-sel':'')+'" type="button" aria-pressed="'+(sel?"true":"false")+'" data-g="'+g+'" data-v="'+o.v+'">'+
    '<span class="cqw-tick">&#10003;</span><span class="cqw-otext"><span class="cqw-oname">'+o.n+'</span>'+
    (o.s?'<span class="cqw-osub">'+o.s+'</span>':'')+'</span></button>';
}
function slideHTML(q,i){
  if(q.kind==="sizing"){
    function row(title,g,list,multi,colsClass){
      return '<div class="cqw-szhead">'+title+'</div><div class="cqw-opts cqw-sz'+(colsClass?' '+colsClass:'')+'">'+list.map(function(o){
        return gBtn(g,o,multi?(S[g].indexOf(o.v)>-1):(S[g]===o.v));
      }).join("")+'</div>';
    }
    return '<div class="cqw-slide" data-i="'+i+'"><div class="cqw-inner">'+
      '<h2 class="cqw-q">'+q.q+'</h2><p class="cqw-hint">'+q.hint+'</p>'+
      '<div class="cqw-body">'+
      row("People in the home","people",[{v:"2",n:"1 to 2"},{v:"4",n:"3 to 4"},{v:"6",n:"5 to 6"},{v:"8",n:"7 or more"}],false,"cqw-sz4")+
      row("Full bathrooms","baths",[{v:"1-2",n:"1 to 2"},{v:"3-4",n:"3 to 4"},{v:"5+",n:"5 or more"}],false,"cqw-sz3")+
      row("Anything that pulls a lot of water at once?","demand",[{v:"simul",n:"Several showers together"},{v:"irrigation",n:"Irrigation or sprinklers"},{v:"pool",n:"A pool or hot tub"},{v:"none",n:"Nothing unusual"}],true)+
      '</div></div></div>';
  }
  var qText=q.q, qHint=q.hint;
  if(q.k==="concerns"){
    if(S.source==="well"){ qText="Any specific worries for your well?"; qHint="Wells are yours to protect. Pick anything you want handled for certain."; }
    else if(S.source==="city"){ qText="Anything you want extra protection from?"; qHint="Your utility treats to federal standards at the plant. This is about <b>your</b> pipes, <b>your</b> taps, and what matters to your family."; }
    else { qText="Anything you want extra protection from?"; }
  }
  if(q.k==="surround" && S.source!=="well"){
    /* the "not sure" route gets geography as its own slide (AJ 2026-07-29) */
    qText="What's around your home?";
    qHint="Whether your water turns out to be city or well, what's nearby leaves clues. Tick anything close to home and we'll flag what's worth testing.";
  }
  var optList=orderedOpts(q).filter(function(o){ return !(o.wellOnly && S.source!=="well"); });
  var opts=optList.map(function(o){ return optBtn(q,i,o); }).join("");
  var moreSel = (q.more||[]).some(function(o){ return q.multi && S[q.k].indexOf(o.v)>-1; });
  /* explicit disclosure state (Sol-converged 2026-07-29): survives re-render,
     collapsible, aria-wired, dynamic count */
  var moreOpen = S._moreOpen===undefined ? moreSel : !!S._moreOpen;
  var moreCount = q.more ? q.more.filter(function(o){ return S[q.k].indexOf(o.v)>-1; }).length : 0;
  var more = q.more
    ? '<button class="cqw-morebtn" type="button" data-more="'+i+'" aria-expanded="'+(moreOpen?"true":"false")+'" aria-controls="cqw-morewrap-'+i+'">'+
      (moreOpen?'Show fewer concerns':'Show '+q.more.length+' more concerns (radon, chromium-6, VOCs&hellip;)'+(moreCount?' &middot; '+moreCount+' selected':''))+'</button>'+
      '<div class="cqw-morewrap" id="cqw-morewrap-'+i+'"'+(moreOpen?'':' hidden')+'><div class="cqw-opts cqw-opts--vital'+((q.more.length%2)?' cqw-odd':'')+'">'+
      q.more.map(function(o){ return optBtn(q,i,o); }).join("")+'</div></div>'
    : '';
  var wellSubH = (q.wellsub && S.source==="well")
    ? '<div class="cqw-szhead">'+q.wellsub.title+'</div><div class="cqw-opts cqw-sz cqw-sz3">'+
      q.wellsub.items.map(function(o){ return gBtn("wellchlor",o,S.wellchlor===o.v); }).join("")+'</div>'
    : '';
  var subH = (q.sub && S.source==="city")
    ? '<div class="cqw-szhead">'+q.sub.title+'</div><div class="cqw-opts">'+
      q.sub.items.map(function(o){ return gBtn("surround",o,S.surround.indexOf(o.v)>-1); }).join("")+'</div>'
    : '';
  return '<div class="cqw-slide" data-i="'+i+'"><div class="cqw-inner">'+
    '<h2 class="cqw-q">'+qText+'</h2><p class="cqw-hint">'+qHint+'</p>'+
    '<div class="cqw-body">'+
    '<div class="cqw-opts'+(q.cols===1?' cqw-one':'')+((q.cols!==1&&optList.length%2)?' cqw-odd':'')+(q.k==="concerns"?' cqw-opts--vital':'')+'">'+opts+'</div>'+
    more+wellSubH+subH+'</div></div></div>';
}
/* the fade mask appears only when the options body genuinely overflows */
function cqwScrollState(){
  var bs = elSlides.querySelectorAll(".cqw-body");
  for(var i=0;i<bs.length;i++){
    var b = bs[i];
    if(b.scrollHeight - b.clientHeight > 4) b.classList.add("is-scrollable");
    else b.classList.remove("is-scrollable");
  }
}
window.addEventListener("resize", cqwScrollState);

function render(){
  if(!S._started){ S._started=1; cqTrack("quiz_start",{}); }
  elSlides.innerHTML = activeQS().map(slideHTML).join("");
  var s=elSlides.querySelector('[data-i="'+idx+'"]'); if(s) s.classList.add("is-on");
  drawRail();
  cqwScrollState();
}

function go(n){
  var cur=elSlides.querySelector('[data-i="'+idx+'"]');
  if(n>idx && cur){ cur.classList.remove("is-on"); cur.classList.add("is-out"); }
  idx=n;
  if(idx>=activeQS().length){ showResult(); return; }
  render();
}

document.getElementById("cqw-next").addEventListener("click",function(){ go(idx+1); });
document.getElementById("cqw-skip").addEventListener("click",function(){
  var q=activeQS()[idx];
  if(q){
    if(q.kind==="sizing"){ S.people=null; S.baths=null; S.demand=[]; }
    else { S[q.k]=q.multi?[]:null; if(q.sub||q.well) S.surround=[]; if(q.wellsub) S.wellchlor=null; }
  }
  go(idx+1);
});
document.getElementById("cqw-back").addEventListener("click",function(){ if(idx>0) go(idx-1); });
elSlides.addEventListener("click",function(e){
  var gopt=e.target.closest(".cqw-opt[data-g]");
  if(gopt){
    var g=gopt.dataset.g, gv=gopt.dataset.v;
    var gmulti=(g==="demand"||g==="surround");
    if(gmulti){
      var ga=S[g], gi=ga.indexOf(gv);
      if(gv==="none"){ S[g]=gi>-1?[]:["none"]; }
      else{ if(gi>-1) ga.splice(gi,1); else { ga.push(gv); var ni=ga.indexOf("none"); if(ni>-1) ga.splice(ni,1); } }
      var wrap=gopt.parentNode;
      [].forEach.call(wrap.querySelectorAll(".cqw-opt"),function(o){ var on=S[g].indexOf(o.dataset.v)>-1; o.classList.toggle("is-sel",on); o.setAttribute("aria-pressed",on?"true":"false"); });
    } else {
      S[g]=gv;
      [].forEach.call(gopt.parentNode.querySelectorAll(".cqw-opt"),function(o){o.classList.remove("is-sel");o.setAttribute("aria-pressed","false");});
      gopt.classList.add("is-sel"); gopt.setAttribute("aria-pressed","true");
    }
    drawRail(); return;
  }
  var opt=e.target.closest(".cqw-opt");
  if(opt){
    var q=activeQS()[+opt.dataset.q], v=opt.dataset.v;
    if(q.multi){
      var a=S[q.k], p=a.indexOf(v);
      if(p>-1){ a.splice(p,1); opt.classList.remove("is-sel"); opt.setAttribute("aria-pressed","false"); }
      else { a.push(v); opt.classList.add("is-sel"); opt.setAttribute("aria-pressed","true");
        if(q.k==="surround") cqTrack("geo_selected",{item:v}); }
      drawRail();
    } else {
      /* Sol-converged 2026-07-29: a source change clears route-specific
         geography state so a city result never inherits hidden well flags */
      if(q.k==="source" && S[q.k]!==v){ S.surround=[]; S.wellchlor=null; }
      S[q.k]=v;
      if(q.k==="scope") cqTrack("scope_selected",{scope:v});
      var sibs=opt.parentNode.querySelectorAll(".cqw-opt");
      for(var i=0;i<sibs.length;i++){ sibs[i].classList.remove("is-sel"); sibs[i].setAttribute("aria-pressed","false"); }
      opt.classList.add("is-sel"); opt.setAttribute("aria-pressed","true");
      drawRail();   /* no auto-advance: the visitor presses Continue */
    }
    return;
  }
  var mb=e.target.closest("[data-more]");
  if(mb){
    /* stateful, collapsible, aria-wired disclosure (Sol-converged 2026-07-29) */
    var mi=+mb.dataset.more, mq=activeQS()[mi];
    var w=document.getElementById("cqw-morewrap-"+mi);
    var wasOpen = w && !w.hidden;
    S._moreOpen = !wasOpen;
    if(w) w.hidden = wasOpen;
    mb.setAttribute("aria-expanded", S._moreOpen?"true":"false");
    var mTotal=(mq&&mq.more)?mq.more.length:0;
    var mSel=(mq&&mq.more)?mq.more.filter(function(o){ return S[mq.k].indexOf(o.v)>-1; }).length:0;
    mb.innerHTML = S._moreOpen ? 'Show fewer concerns'
      : 'Show '+mTotal+' more concerns (radon, chromium-6, VOCs&hellip;)'+(mSel?' &middot; '+mSel+' selected':'');
    /* keep the chrome frozen: only the options body scrolls to the reveal */
    if(S._moreOpen && w){
      var bodyEl = mb.parentNode;
      while(bodyEl && String(bodyEl.className).indexOf("cqw-body")<0) bodyEl = bodyEl.parentNode;
      if(bodyEl) bodyEl.scrollTop = mb.offsetTop - 8;
    }
    cqwScrollState();
    cqTrack("more_toggle",{open:S._moreOpen?1:0});
    return;
  }
  if(e.target.closest("[data-back]")){ if(idx>0) go(idx-1); return; }
  if(e.target.closest("[data-next]")||e.target.closest("[data-skip]")){ go(idx+1); }
});

/* ---- result: every string DERIVED from the picked product ---- */
/* ---- proven logic ported verbatim from the original Water Wizard ---- */
var MAP = {
    notice: {
      chlorine:[{canonical_id:"tthm", value:0.05, unit:"mg/L"}],
      egg:     [{canonical_id:"h2s", value:0.3, unit:"mg/L"}],   // rotten-egg = hydrogen sulfide -> oxidation stage
      orange:  [{canonical_id:"iron", value:1.0, unit:"mg/L"}],
      scale:   [{canonical_id:"hardness", value:12, unit:"gpg"}],
      blue:    [{canonical_id:"copper", value:1.0, unit:"mg/L"}],
      tint:    [{canonical_id:"tannins", value:1, unit:"mg/L"}],
      salty:   [{canonical_id:"tds", value:400, unit:"mg/L"}],
      metallic:[{canonical_id:"iron", value:0.5, unit:"mg/L"}],
    },
    // what an expert reads from your surroundings: WATCH FLAGS, not confirmed
    // detections. Proximity alone never buys a treatment system - it earns a
    // "test for this" pointer (2026-07-14 audit: hard values from soft evidence
    // forced dedicated systems/RO off a single checkbox).
    surround: {},
    concerns: {
      lead:    [{canonical_id:"lead", value:0.02, unit:"mg/L"}],
      pfas:    [{canonical_id:"pfoa", value:0.02, unit:"ug/L"}],
      arsenic: [{canonical_id:"arsenic", value:0.01, unit:"mg/L"}],
      nitrate: [{canonical_id:"nitrate", value:10, unit:"mg/L"}],
      fluoride:[{canonical_id:"fluoride", value:4, unit:"mg/L"}],
      iron:    [{canonical_id:"iron", value:1.0, unit:"mg/L"}],
      hardness:[{canonical_id:"hardness", value:12, unit:"gpg"}],
      chromium6:[{canonical_id:"chromium6", value:0.005, unit:"mg/L"}],
      radon:   [{canonical_id:"radon", value:300, unit:"pCi/L"}],
      uranium: [{canonical_id:"uranium", value:0.03, unit:"mg/L"}],
      mercury: [{canonical_id:"mercury", value:0.002, unit:"mg/L"}],
      vocs:    [{canonical_id:"benzene", value:0.005, unit:"mg/L"}],
      sulfate: [{canonical_id:"sulfate", value:250, unit:"mg/L"}],
      /* microplastics: routes via ctx.microplastics_intent (AJ ruling
         2026-07-29: RO main fix, SMART media alternative) - an intent flag,
         never a fabricated detection, so no MAP entry here */
    }
  };

  // surroundings -> "worth testing for" advisory cards (soft evidence)
var WATCH = {
    farm:     {label:"Nitrate & pesticides", why:"Fertilizer runoff reaches groundwater in farm country.", cid:"nitrate"},
    woods:    {label:"Tannins & organic color", why:"Decaying vegetation tints well water yellow-brown.", cid:"tannins"},
    industry: {label:"PFAS (forever chemicals)", why:"Industrial sites, airports, military bases and training grounds historically used PFAS firefighting foam.", cid:"pfoa"},
    fuel:     {label:"VOCs (fuel & solvent compounds)", why:"Underground tanks and dry-cleaning solvents migrate into groundwater.", cid:"benzene"},
    oldhome:  {label:"Lead", why:"Homes built before 1990 often have lead solder or fixtures - test at the tap.", cid:"lead"},
    septic:   {label:"Bacteria & nitrate", why:"Septic proximity is the classic source of coliform and nitrate in wells.", cid:"nitrate"},
    cemetery: {label:"Arsenic", why:"Arsenic embalming compounds were used into the early 1900s.", cid:"arsenic"},
    /* geology signals (Sol-converged 2026-07-29, USGS-grounded): granite
       bedrock = radon + uranium/radium; volcanic = silica. Soft flags only,
       and no kit claim until the kit panels are verified (nokit) */
    bedrock:  [{label:"Radon", why:"Granite bedrock regions can send radon into well water. Granular activated carbon contact reduces radon, and the SMART, Eagle and Guardian beds all carry GAC; a radon water test confirms your level so the carbon contact is sized right.", cid:"radon", nokit:true},
               {label:"Uranium & radium", why:"The same granite bedrock can carry uranium and radium. Testing confirms before any dedicated treatment.", cid:"uranium", nokit:true}],
    volcanic: {label:"Silica", why:"Volcanic rock sheds silica, the white scale a softener cannot remove. A silica test settles it.", cid:"silica", nokit:true},
  };

function watchFlags(seen){
    var out=[], had={};
    S.surround.forEach(function(x){
      var w=WATCH[x]; if(!w) return;
      (Array.isArray(w)?w:[w]).forEach(function(f){
        if(had[f.label]) return;
        if(seen[f.cid]) return;  // already confirmed by report/records/concern
        had[f.label]=1; out.push(f);
      });
    });
    /* microplastics now ROUTES (AJ ruling 2026-07-29: RO main fix, SMART
       media alternative) - the old advisory-only flag is gone */
    if(S.srcUnsure) out.push({label:"Confirm your water source",
      why:"City and well water need different protection - check your water bill or ask your neighbors."});
    return out;
  }

function buildProfile(){
    var seen={}, prof=[], prov={};
    function addAll(list, src){ (list||[]).forEach(function(e){ if(!seen[e.canonical_id]){ seen[e.canonical_id]=1; prov[e.canonical_id]=src; prof.push(e); } }); }
    addAll(S.reportProfile, "report");                 // their real numbers win
    if(S.source!=="well") addAll(S.zipProfile, "records");  // municipal records don't describe a private well
    // explicit concerns are PREFERENCES: if the record's value for the same
    // contaminant sits below the concern's trigger, the user's want-it-treated
    // intent wins (a 0.7 mg/L fluoride record must not silence "I want
    // fluoride out")
    function mgl(v,u){ var f={"mg/l":1,"ppm":1,"ug/l":.001,"ppb":.001,"ng/l":1e-6,"ppt":1e-6,"gpg":1};
      u=(u||"mg/L").toLowerCase(); return u in f ? v*f[u] : null; }
    S.concerns.forEach(function(c){
      (MAP.concerns[c]||[]).forEach(function(e){
        if(!seen[e.canonical_id]){ seen[e.canonical_id]=1; prov[e.canonical_id]="concern"; prof.push(e); return; }
        for(var i=0;i<prof.length;i++){
          if(prof[i].canonical_id===e.canonical_id){
            var cur=mgl(prof[i].value,prof[i].unit), want=mgl(e.value,e.unit);
            if(cur!=null && want!=null && cur<want){ prof[i]=e; prov[e.canonical_id]="concern"; }
          }
        }
      });
    });
    S.notice.forEach(function(n){ addAll(MAP.notice[n], "symptom"); });
    // surroundings stay SOFT: they become "worth testing for" flags, not detections
    var ctx={ source: S.source==="well"?"well":"city", people:S.people };
    if(S.source==="well" && S.wellchlor==="yes") ctx.continuous_chlorination=true;
    if(S.concerns.indexOf("bacteria")>-1) ctx.coliform=true;
    if(S.notice.indexOf("cloudy")>-1) ctx.clarity="cloudy";
    /* AJ ruling 2026-07-29: microplastics routes as an INTENT context flag
       (RO main fix, SMART media alternative) - never a fabricated number */
    if(S.concerns.indexOf("microplastics")>-1) ctx.microplastics_intent=true;
    /* AJ 2026-08-03: the band's build-mode toggle - "one RO system" mode
       asks the ORACLE for the RO-primary design (incl. required
       pretreatment); the UI never improvises an RO train. prefer_ro is the
       presenter's switch (it forces the RO train AND the RO-primary card) */
    if(S.buildMode==="ro") ctx.prefer_ro=true;
    var hasMeasured=false;
    for(var pk in prov){ if(prov[pk]==="report"||prov[pk]==="records") hasMeasured=true; }
    return {profile:prof, ctx:ctx, seen:seen, prov:prov, hasMeasured:hasMeasured};
  }

  /* S fields the ported enrichment layer fills in AFTER the first result */
  S.reportProfile = S.reportProfile || [];
  S.zipProfile    = S.zipProfile    || [];
  S.people        = S.people        || undefined;
  S.zip = ""; S.zipUtil = null; S.zipApprox = false;
  S.reportChips = []; S.reportNonDetects = [];

/* ================= POST-RESULT ENRICHMENT (ported from the original Water Wizard) =================
   AJ placement ruling: ZIP + report are offered AFTER the result as refinement, never gating.
   Success re-runs the engine (buildProfile precedence: report > records > concerns > senses > goals)
   and redraws the result. On a well the ZIP card is not offered (municipal records never mix in). */

/* Lazy PDF text extraction via self-hosted pdf.js (vendor/, loaded only when needed) */
var pdfReady = null;
function loadPdfJs(){
  if (pdfReady) return pdfReady;
  pdfReady = new Promise(function(resolve, reject){
    var s = document.createElement("script");
    s.src = assetUrl("vendor/pdf.min.js");
    s.onload = function(){
      var lib = window.pdfjsLib || window["pdfjs-dist/build/pdf"];
      lib.GlobalWorkerOptions.workerSrc = assetUrl("vendor/pdf.worker.min.js");
      resolve(lib);
    };
    s.onerror = function(){ reject(new Error("pdf.js failed to load")); };
    document.head.appendChild(s);
  });
  return pdfReady;
}
function pdfToText(file){
  return loadPdfJs().then(function(pdfjs){
    return file.arrayBuffer().then(function(buf){
      return pdfjs.getDocument({data: buf}).promise;
    }).then(function(doc){
      var pages = [];
      for (var i = 1; i <= Math.min(doc.numPages, 30); i++) pages.push(i);
      return pages.reduce(function(chain, n){
        return chain.then(function(txt){
          return doc.getPage(n).then(function(pg){ return pg.getTextContent(); })
            .then(function(tc){
              // group items into lines by their y position so "Name .... value unit"
              // rows survive extraction. Bucket by y, then sort each row's
              // items by x so multi-column table rows read left-to-right
              // (name ... value ... unit) instead of content-stream order.
              var rows = {};
              tc.items.forEach(function(it){
                var y = Math.round(it.transform[5]);
                (rows[y] = rows[y] || []).push({x: it.transform[4], s: it.str});
              });
              var lines = Object.keys(rows).sort(function(a,b){ return b-a; })
                .map(function(y){
                  return rows[y].sort(function(a,b){ return a.x - b.x; })
                    .map(function(o){ return o.s; }).join(" ");
                }).join("\n");
              return txt + "\n" + lines;
            });
        });
      }, Promise.resolve(""));
    });
  });
}

  /* ---------- report parsing (fully client-side) ----------
     Hardened 2026-07-14 (audit A5): non-detects never become positive
     detections; a row with no usable unit is skipped rather than defaulted to
     mg/L (a wrong default fabricated 1000x errors); CCR tables with several
     numbers per row pick the value adjacent to a unit; scientific notation and
     thousands separators parse; relaxed name matching only fires on a real
     data row. Pure logic lives in CQParser so it can be unit-tested.
     BYTE-IDENTICAL copy of the proven parser in quiz.html - parser.test.js
     asserts the two never drift. Do not hand-edit this copy. */
  var CQParser = (function(){
    // unit token -> canonical unit string the engine understands
    var UNIT_MAP = {
      "ug/l":"ug/L","µg/l":"ug/L","μg/l":"ug/L","mcg/l":"ug/L","ppb":"ppb",
      "mg/l":"mg/L","ppm":"ppm","ng/l":"ng/L","ppt":"ppt","pci/l":"pCi/L",
      "gpg":"gpg","grains/gal":"gpg","ntu":"NTU","g/l":"g/L"
    };
    var UNIT_RE = "(?:ug/l|µg/l|μg/l|mcg/l|mg/l|ppm|ppb|ppt|ng/l|pci/l|gpg|grains/gal|ntu|g/l)";
    // number: optional sign, digits w/ thousands separators or leading dot, optional exponent
    var NUM = "[+-]?(?:\\d{1,3}(?:,\\d{3})+|\\d+|\\.\\d+)(?:\\.\\d+)?(?:[eE][+-]?\\d+)?";
    var NUMU = new RegExp("(" + NUM + ")\\s*(" + UNIT_RE + ")?", "gi");
    var QUAL = /(^|[\s,;:])(nd|n\/d|bdl|non-?detect(?:ed)?|not\s+detected|absent|<mdl|<rl)(?=$|[\s,;:])/i;

    function normNum(s){
      return parseFloat(String(s).replace(/,/g, ""));
    }
    function normUnit(u){
      return u ? (UNIT_MAP[u.toLowerCase()] || null) : null;
    }
    // Parse one line's data portion. Returns {value,unit} or {nonDetect:true} or null.
    function parseValue(rest){
      if (/[<>]\s*[\d.]/.test(rest) || QUAL.test(rest)) return {nonDetect:true};
      var pairs = [], m;
      NUMU.lastIndex = 0;
      while ((m = NUMU.exec(rest)) !== null) {
        var v = normNum(m[1]);
        if (isNaN(v)) continue;
        pairs.push({v:v, u:normUnit(m[2])});
      }
      if (!pairs.length) return null;
      // prefer the first number that carries a unit (the detected level in a
      // multi-column CCR row); else, if exactly one number total, use it.
      var withUnit = pairs.filter(function(p){ return p.u; });
      var pick = withUnit.length ? withUnit[0] : (pairs.length === 1 ? pairs[0] : null);
      if (!pick) return null;                    // ambiguous multi-number row w/o units
      if (!pick.u) return null;                  // no usable unit -> skip, never default
      if (!(pick.v > 0)) return {nonDetect:true};
      return {value:pick.v, unit:pick.u};
    }

    function norm(s){
      return s.trim().toUpperCase().replace(/[\s_]+/g," ").replace(/[\[\]]/g,"").trim();
    }
    function aliasHit(A, name){
      var n = norm(name);
      if (A[n]) return A[n];
      var base = n.split(/[,(]/)[0].trim();       // strip a trailing qualifier
      if (base && base !== n && A[base]) return A[base];
      return null;
    }
    // Longest leading-word run that matches an alias AND leaves a rest that
    // parses to a value. Handles multi-word and numeric chemical names
    // ("Gross Alpha", "1,4-Dioxane", "Total Trihalomethanes (TTHM)") while
    // never splitting inside a word (so "Leadville" can't match "lead").
    function splitNameValue(A, line){
      var words = line.replace(/^\s*"?|"?\s*$/g,"").split(/\s+/);
      for (var k = Math.min(7, words.length - 1); k >= 1; k--){
        var nm = words.slice(0, k).join(" ");
        var cid = aliasHit(A, nm);
        if (!cid) continue;
        var rest = words.slice(k).join(" ");
        var pv = parseValue(rest);
        if (pv) return {cid:cid, rest:rest, pv:pv, name:nm};
      }
      return null;
    }

    // Split a CSV line respecting quoted fields (RFC-4180-ish).
    function csvSplit(line){
      var out=[], cur="", q=false;
      for (var i=0;i<line.length;i++){
        var c=line[i];
        if (q){ if (c === '"' && line[i+1] === '"'){ cur+='"'; i++; } else if (c === '"'){ q=false; } else cur+=c; }
        else { if (c === '"') q=true; else if (c === ",") { out.push(cur); cur=""; } else cur+=c; }
      }
      out.push(cur);
      return out.map(function(s){ return s.trim(); });
    }
    function headerIndex(cols){
      var idx={analyte:-1,result:-1,unit:-1};
      cols.forEach(function(c,i){
        var l=c.toLowerCase();
        if (idx.analyte<0 && /(analyte|contaminant|parameter|substance|name)/.test(l)) idx.analyte=i;
        if (idx.result<0 && /(result|level detected|detected|average|amount|value|concentration|conc\.)/.test(l)) idx.result=i;
        if (idx.unit<0 && /(unit|units|uom)/.test(l)) idx.unit=i;
      });
      return (idx.analyte>=0 && idx.result>=0) ? idx : null;
    }

    // returns {detections:[{canonical_id,value,unit,name}], nonDetects:[names]}
    function parse(text, A){
      var found={}, order=[], nonDet=[];
      var lines = String(text).split(/\r?\n/);
      // CSV path: header row present?
      var csvIdx=null, headerRow=-1;
      for (var h=0; h<Math.min(lines.length,5); h++){
        if (lines[h].indexOf(",")>-1){
          var ix=headerIndex(csvSplit(lines[h]));
          if (ix){ csvIdx=ix; headerRow=h; break; }
        }
      }
      lines.forEach(function(line, li){
        if (!line.trim()) return;
        var rawName, rest;
        var cid, pv, label;
        if (csvIdx && li>headerRow){
          var cols=csvSplit(line);
          rawName = cols[csvIdx.analyte]||"";
          rest = (cols[csvIdx.result]||"") + " " + (csvIdx.unit>=0 ? (cols[csvIdx.unit]||"") : "");
          if (!rawName) return;
          cid = aliasHit(A, rawName);
          if (!cid) return;
          pv = parseValue(rest);
          label = rawName.trim();
        } else if (csvIdx){
          return; // header or pre-header line in CSV mode
        } else {
          var sv = splitNameValue(A, line);
          if (!sv) return;
          cid = sv.cid; pv = sv.pv; label = sv.name;
        }
        if (!pv) return;
        if (pv.nonDetect){ if (nonDet.indexOf(label)<0) nonDet.push(label); return; }
        if (found[cid]) return;                 // first solid detection wins
        found[cid] = {canonical_id:cid, value:pv.value, unit:pv.unit, name:label};
        order.push(cid);
      });
      return {detections: order.map(function(k){ return found[k]; }), nonDetects: nonDet};
    }
    return {parse:parse, parseValue:parseValue, _csvSplit:csvSplit};
  })();

function parseReport(text){
  var loadAliases = cache.aliases?Promise.resolve(cache.aliases)
    :getJSON("data/aliases.json").then(function(a){cache.aliases=a;return a;});
  return loadAliases.then(function(A){
    var r = CQParser.parse(text, A);
    S.reportProfile = r.detections.map(function(d){
      return {canonical_id:d.canonical_id, value:d.value, unit:d.unit};
    });
    S.reportChips = r.detections.map(function(d){ return d.name; });
    S.reportNonDetects = r.nonDetects;
    return S.reportChips.length;
  });
}

/* ---------- zip records pull (lookup chain verbatim from the original; only DOM ids/classes differ,
   and success re-runs the engine instead of printing inline). All 5 honest failure strings kept. ---------- */
function checkZip(){
  var inp=document.getElementById("cqr-zip"), out=document.getElementById("cqr-zipout");
  var z=(inp&&inp.value||"").trim();
  if(!/^\d{5}$/.test(z)){ if(out) out.innerHTML="<div class='cqr-refnote'>Enter a 5-digit ZIP first.</div>"; return; }
  S.zip=z; S.zipUtil=null; S.zipApprox=false; S.zipProfile=[];   // never let an older lookup's data survive
  var seq=++zipSeq;
  if(out) out.innerHTML="<div class='cqr-spin'>Checking public records&hellip;</div>";
  (cache.zipIndex?Promise.resolve(cache.zipIndex):getJSON("data/zip_index.json").then(function(d){cache.zipIndex=d;return d;}))
    .then(function(zi){
      var pids=zi[z]||[];
      if(!pids.length)
        return (cache.fb?Promise.resolve(cache.fb):getJSON("data/zip_fallback.json").then(function(d){cache.fb=d;return d;}))
          .then(function(fb){ var e=fb[z]||{}; var r=e.pwsids||[]; r._approx=true; return r; });
      return pids;
    })
    .then(function(pids){
      if(seq!==zipSeq) return;
      if(!pids.length){ if(out) out.innerHTML="<div class='cqr-refnote'>No public records indexed for "+esc(z)+", no problem, your answers still give us plenty to work with.</div>"; return; }
      var sts={}; pids.forEach(function(p){ sts[p.slice(0,2)]=1; });
      return Promise.all(Object.keys(sts).map(function(st){ return getJSON("data/utilities-"+st+".json").then(function(d){ return {st:st,d:d}; }); }))
        .catch(function(){ if(out) out.innerHTML="<div class='cqr-refnote'>Area records are not available on this page yet, no problem, your answers already carry the design.</div>"; return null; })
        .then(function(shards){
          if(!shards) return;
          if(seq!==zipSeq) return;
          // county-majority first, then population (mirrors hub.html)
          var cand=[];
          shards.forEach(function(sh){ pids.forEach(function(p){
            var u=sh.d[p]; if(u) cand.push({p:p,name:u.name,county:u.county,pop:u.pop,detected:u.detected});
          });});
          var cc={}; cand.forEach(function(u){ var c=(u.county||"").toUpperCase(); if(c) cc[c]=(cc[c]||0)+1; });
          var mode=Object.keys(cc).sort(function(a,b){ return cc[b]-cc[a]; })[0]||"";
          cand.sort(function(a,b){
            var am=((a.county||"").toUpperCase()===mode)?0:1, bm=((b.county||"").toUpperCase()===mode)?0:1;
            return am-bm || num(b.pop)-num(a.pop);
          });
          var best=cand[0]||null;
          if(!best){ if(out) out.innerHTML="<div class='cqr-refnote'>No detailed data for "+esc(z)+" yet.</div>"; return; }
          S.zipUtil={name:best.name,county:best.county,n:best.detected.length};
          S.zipApprox=!!pids._approx;
          S.zipProfile=best.detected.map(function(d){ return {canonical_id:d.canonical_id,value:d.value,unit:d.unit}; });
          rerun("zip");   // fold the records into the result and redraw
        });
    })
    .catch(function(){ if(out) out.innerHTML="<div class='cqr-refnote'>Couldn't reach the records right now, continuing with your answers.</div>"; });
}

/* ---------- the refine section on the result screen ---------- */
function setParseOut(h){ var o=document.getElementById("cqr-parseout"); if(o) o.innerHTML=h; }
function afterParse(n){
  if(n){ rerun("report"); return; }
  var nd=S.reportNonDetects||[];
  if(nd.length){
    setParseOut("<div class='cqr-strip'>&#10003; Everything we recognized reads as not detected: "+nd.map(esc).join(", ")+". Good news, and nothing here changes your result.</div>");
  } else {
    setParseOut("<div class='cqr-refnote'>We couldn't match any contaminant lines. Try the format: <i>Lead 0.012 mg/L</i>, one per line.</div>");
  }
}
function readReportFile(f){
  if(!f) return;
  if(/\.pdf$/i.test(f.name)){
    setParseOut("<div class='cqr-spin'>Reading your PDF&hellip;</div>");
    pdfToText(f).then(function(text){
      var p=document.getElementById("cqr-paste"); if(p) p.value=String(text).slice(0,200000);
      return parseReport(String(text)).then(afterParse);
    }).catch(function(){ setParseOut("<div class='cqr-refnote'>Couldn't read that PDF (it may be a scanned image). Copy-paste the results table instead.</div>"); });
    return;
  }
  var r=new FileReader();
  r.onload=function(){
    var p=document.getElementById("cqr-paste"); if(p) p.value=String(r.result).slice(0,200000);
    parseReport(String(r.result)).then(afterParse);
  };
  r.readAsText(f);
}
function renderRefine(){
  var host=document.getElementById("cqr-refine"); if(!host) return;
  var zipCard="";
  /* AJ 2026-08-03: all test talk lives HERE, at the very bottom below the
     email capture - the well test-kit card sits beside the report card */
  if(S.source==="well" && MODE!=="report"){
    zipCard = '<div class="cqr-ref"><p class="cqr-ref-h">Want certainty? Test your well</p>'+
      '<p class="cqr-ref-p">Your answers got us to the right starting point. A quick well test confirms the exact design before you spend a dollar on the wrong stage.</p>'+
      '<div class="cqr-ref-row"><a class="cqr-ref-btn" style="text-decoration:none" href="'+urlFor("well-water-test")+'" target="_blank" rel="noopener">Get the well test kit</a></div></div>';
  }
  if(S.source!=="well"){
    zipCard = S.zipUtil
      ? '<div class="cqr-ref"><p class="cqr-ref-h">Your area&#39;s public records</p>'+
        '<div class="cqr-strip">&#10003; Found <b>'+esc(S.zipUtil.name)+'</b>'+(S.zipUtil.county?' ('+esc(S.zipUtil.county)+')':'')+
        ', <b>'+S.zipUtil.n+'</b> contaminants on public record. Your result above now factors in every one of them. '+
        (CQW_LOCAL_LINKS?'<a href="hub.html?zip='+esc(S.zip)+'">See your area&#39;s full report</a>':'')+'</div>'+
        (S.zipApprox?'<div class="cqr-refnote">This ZIP maps approximately (county-level), so we matched the most likely nearby system. Your answers matter more than the exact match.</div>':'')+
        '</div>'
      : '<div class="cqr-ref"><p class="cqr-ref-h">Want us to check your area&#39;s records?</p>'+
        '<p class="cqr-ref-p">Enter your ZIP and we pull the contaminants actually reported by your local water system, then fold every one of them into this result.</p>'+
        '<div class="cqr-ref-row"><input class="cqr-zin" id="cqr-zip" inputmode="numeric" maxlength="5" placeholder="ZIP code" value="'+esc(S.zip)+'" aria-label="ZIP code">'+
        '<button class="cqr-ref-btn" id="cqr-zbtn" type="button">Check my records</button></div><div id="cqr-zipout"></div></div>';
  }
  var repCard;
  if(MODE==="report"){
    repCard = '<div class="cqr-ref"><p class="cqr-ref-h">New numbers?</p>'+
      (S.reportChips.length?'<div style="margin:0 0 10px">'+S.reportChips.map(function(c){return '<span class="cqr-pchip">&#10003; '+esc(c)+'</span>';}).join("")+'</div>'+
        ((S.reportNonDetects||[]).length?'<div class="cqr-refnote" style="margin:0 0 10px">Not detected (no action needed): '+S.reportNonDetects.map(esc).join(", ")+'</div>':''):'')+
      '<p class="cqr-ref-p">Analyze a different report any time; the design updates from whatever you feed it.</p>'+
      '<div class="cqr-ref-row"><button class="cqr-ref-btn" id="cqr-rt-again" type="button">Analyze another report</button></div></div>';
  } else {
    repCard = '<div class="cqr-ref"><p class="cqr-ref-h">Have a water test or utility report?</p>'+
      '<p class="cqr-ref-p">'+(S.source==="well"?"On a well, your own test is the accurate path. ":"")+
      'Our Report Analyzer reads it, PDF, CSV or pasted text, right in your browser, and designs from your real numbers instead of assumptions.</p>'+
      '<div class="cqr-ref-row"><a class="cqr-ref-btn" style="text-decoration:none" href="?mode=report&amp;src='+(S.source==="well"?"well":"city")+'">Open the Report Analyzer</a></div></div>';
  }
  host.className = "cqr-refine"+(zipCard?"":" cqr-solo");
  host.innerHTML = zipCard+repCard;
  var zbtn=document.getElementById("cqr-zbtn"); if(zbtn) zbtn.addEventListener("click", checkZip);
  var zin=document.getElementById("cqr-zip");
  if(zin) zin.addEventListener("keydown", function(e){ if(e.key==="Enter"){ e.preventDefault(); checkZip(); } });
  var again=document.getElementById("cqr-rt-again");
  if(again) again.addEventListener("click", function(){ document.getElementById("cqr-restart").click(); });
}
var DIFFCTX=null;
function rerun(src){
  DIFFCTX = LAST.anchorName ? { src:src||"", cids:(LAST.cids||[]).slice(), anchor:LAST.anchorName } : null;
  if(src==="zip") cqTrack("refine_zip",{}); else if(src==="report") cqTrack("refine_report",{});
  showResult();
  /* the refine row lives at the very bottom now (AJ 2026-08-03): after a
     ZIP or report re-run, bring the reader back to the updated verdict and
     the what-changed strip at the top */
  window.scrollTo(0,0);
}
function prettyCid(c){
  var TH=(ENGINE_DATA.THRESHOLDS||{})[c]; if(TH&&TH.name) return TH.name;
  var ZT=(ENGINE_DATA.ZERO_TOLERANCE||{})[c]; if(ZT&&ZT.name) return ZT.name;
  return c;
}
var RESTART_SVG='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:5px" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"></path><polyline points="3 4 3 9 8 9"></polyline></svg>';
function renderScopeToggle(){
  var host=document.getElementById("cqr-scope"); if(!host) return;
  /* unsure-source comparison (Sol-converged 2026-07-29): disclosed city
     default plus a one-tap well re-run; S.srcUnsure is the immutable
     sentinel (rendered as a segmented group in the top bar below) */
  /* AJ 2026-08-03: one clean control bar in the card design language
     (segmented groups, matching the softener/salt-free control), never a
     pile of pills - view group, build-style group, quiet restart */
  var bmodeSeg = (S.view!=="pou" && LAST.res && (S.buildMode==="ro" || !LAST.anchorIsRo))
    ? '<div class="cqr-seg cqr-seg--bar" role="group" aria-label="Build style">'+
      '<button type="button" class="cqr-seg-btn'+(S.buildMode==="ro"?'':' is-on')+'" data-bmode="media">Recommended build</button>'+
      '<button type="button" class="cqr-seg-btn'+(S.buildMode==="ro"?' is-on':'')+'" data-bmode="ro">Maximum purity (RO)</button></div>'
    : '';
  var srcSeg = S.srcUnsure
    ? '<div class="cqr-seg cqr-seg--bar" role="group" aria-label="Water source">'+
      '<button type="button" class="cqr-seg-btn'+(S.source!=="well"?' is-on':'')+'" data-srcview="city">Assumed city</button>'+
      '<button type="button" class="cqr-seg-btn'+(S.source==="well"?' is-on':'')+'" data-srcview="well">See it as a well</button></div>'
    : '';
  host.innerHTML='<div class="cqr-topbar">'+
    '<div class="cqr-seg cqr-seg--bar" role="group" aria-label="View">'+
    '<button type="button" class="cqr-seg-btn'+(S.view!=="pou"?' is-on':'')+'" data-view="whole">Whole home</button>'+
    '<button type="button" class="cqr-seg-btn'+(S.view==="pou"?' is-on':'')+'" data-view="pou">Drinking water only</button></div>'+
    bmodeSeg+srcSeg+
    '<button type="button" class="cqr-mini cqr-topbar-restart" data-restart2>'+RESTART_SVG+'Start over</button>'+
    '</div>'+
    (S.srcUnsure?'<p class="cqr-togsub">Not sure of your source? One tap compares the two designs. Your water bill settles it: a bill means city.</p>':'')+
    (S.scope==="unsure"?'<p class="cqr-togsub">You asked us to show both ways. One tap switches; both are built from the same answers.</p>':'');
}
function kitFor(cid){
  /* catalog-real test kits only: lead gets the dedicated first-draw kit,
     everything else routes to the right source kit */
  if(cid==="lead"){ var r=regRow("first-draw-flush-dual-lead-test"); if(r) return r; }
  return regRow(S.source==="well" ? "well-water-test" : "city-water-test") ||
         { name:"Water Test Kit", url:urlFor(S.source==="well"?"well-water-test":"city-water-test") };
}
function renderFlags(b){
  var flags = watchFlags(b.seen||{});
  var fe=document.getElementById("cqr-flags");
  if(flags && flags.length){
    fe.hidden=false;
    fe.innerHTML='<p class="cqr-flags-h">Worth testing for, based on your answers</p>'+
      '<p class="cqr-flags-p">Location and symptoms are clues, not a diagnosis. A simple test settles each of these before you spend anything.</p>'+
      '<div class="cqr-strip" style="margin:0 0 4px">Test first, buy smart: real numbers design the exact system, no guesswork.</div>'+
      flags.map(function(f){
        /* nokit flags (geology signals): the kit panel is not verified for the
           analyte, so route to a specialist instead of promising a kit */
        var act;
        if(f.nokit){
          act='<a class="cqr-mini cqr-mini--fill" href="https://crystalquest.com/pages/contact-us" target="_blank" rel="noopener">Talk to a specialist</a>';
        } else {
          var kit=kitFor(f.cid);
          act='<a class="cqr-mini cqr-mini--fill" href="'+kit.url+'" target="_blank" rel="noopener">Get the '+esc(kit.name)+'</a>';
        }
        return '<div class="cqr-flag"><b>'+esc(f.label||"")+'</b><span>'+esc(f.why||"")+'</span>'+
          '<div class="cqr-flagact">'+act+
          (f.cid&&CQW_LOCAL_LINKS?'<a class="cqr-mini" href="contaminant.html?c='+esc(f.cid)+'" target="_blank" rel="noopener">Expert guide</a>':'')+
          '</div></div>';
      }).join("");
  } else { fe.hidden=true; }
}
function pouCard(a, crowned, label){
  return '<article class="cqr-card'+(crowned?' cqr-card--rec':'')+'">'+
    (crowned?'<span class="cqr-ribbon">'+esc(label||"Our pick for your tap")+'</span>':'')+
    '<p class="cqr-tierlabel">'+esc(a.tier||"")+'</p>'+
    '<div class="cqr-plate">'+(a.img?'<img src="'+a.img+'" alt="'+esc(a.name)+'">':'')+'</div>'+
    '<h3 class="cqr-name">'+esc(a.name)+'</h3>'+priceSlot(a.handle)+
    '<ul class="cqr-why"><li>'+esc(a.why)+'</li></ul>'+
    '<div class="cqr-actions"><a class="cqr-btn '+(crowned?'cqr-btn--solid cqr-btn--lg':'cqr-btn--ghost')+'" href="'+a.url+'" target="_blank" rel="noopener">'+(crowned?'Configure this system':'Choose options')+'</a>'+
    (crowned?'<a class="cqr-btn cqr-btn--ghost" href="'+a.url+'" target="_blank" rel="noopener">View details</a>':'')+
    '</div></article>';
}
function renderPou(b,res){
  /* the drinking-water-only path: an ELIGIBILITY matrix, never a price ladder.
     Specialty under-sink/countertop lines exist for lead/arsenic/fluoride/nitrate;
     RO is the broad-coverage default; pitcher/faucet only for aesthetic profiles. */
  document.getElementById("cqr-band").style.display="none";
  var AES={tthm:1,hardness:1,h2s:1,tannins:1,tds:1,sulfate:1,ph:1};
  var cids=(b.profile||[]).map(function(e){return e.canonical_id;});
  var health=cids.filter(function(c){return !AES[c];});
  var bact=!!b.ctx.coliform;
  var SPECIALTY={lead:1,arsenic:1,fluoride:1,nitrate:1};
  var famList=[]; health.forEach(function(c){ if(SPECIALTY[c] && famList.indexOf(c)<0) famList.push(c); });
  var onlyFam=(famList.length===1 && health.length===1)?famList[0]:null;
  function prod(h,why,tier){ var r=regRow(h)||{}; return {handle:h,name:r.name||h,url:urlFor(h),img:(r.img||""),why:why,tier:tier}; }
  /* registry-derived configuration copy (AJ 2026-07-29; configs live-verified
     from the store): specialty lines stack dedicated cartridge -> SMART ->
     carbon polish; the SMART lines stack SMART -> carbon block -> sediment */
  function cfgLine(h, kind, wantFull){
    var r=regRow(h); var cs=(r&&r.configs)||[];
    if(cs.length<2) return "";
    if(kind==="specialty"){
      return wantFull
        ? " Spec the Triple configuration here: it pairs the dedicated cartridge with the SMART broad-spectrum stage and a carbon polish, covering the taste and chemical flags in your answers in the same unit."
        : " It comes in "+cs.join(", ")+" cartridge configurations: the Double adds the SMART broad-spectrum stage, the Triple adds a carbon polish on top.";
    }
    return " It comes in "+cs.join(", ")+" cartridge configurations: the Double adds a carbon block stage, the Triple adds a sediment pre-filter.";
  }
  var mpIntent = !!(b.ctx && b.ctx.microplastics_intent);
  var rec, alts=[], budget=[];
  if(bact){
    rec=prod("reverse-osmosis-under-sink-water-filter-4000c","Bacteria risk in your answers: under-sink reverse osmosis finished with UV and a UF polish capsule.","Drinking water only");
    alts.push(prod("reverse-osmosis-under-sink-water-filter-1000c","The broad-coverage under-sink RO, without the UV stage.","Alternative"));
  } else if(mpIntent){
    /* AJ ruling 2026-07-29: microplastics = RO main fix, SMART acceptable */
    rec=prod("reverse-osmosis-under-sink-water-filter-1000c", health.length
      ? "You asked about microplastics plus "+health.slice(0,2).map(prettyCid).join(", ")+": under-sink reverse osmosis is the surest reduction for the lot at the tap."
      : "You asked about microplastics: plastic particles are membrane work, and under-sink reverse osmosis is the surest reduction at the tap.","Drinking water only");
    alts.push(prod("countertop-reverse-osmosis-water-filters","Reverse osmosis without opening the cabinet.","No plumbing"));
    if(!health.length) alts.push(prod("smart-under-sink-water-filter-system","The budget-friendly carbon route: SMART media also reduces microplastics. The reverse osmosis pick above is the stronger reduction.","Good value, carbon"));
  } else if(onlyFam){
    rec=prod(onlyFam+"-under-sink-water-filter-system","The dedicated under-sink system for "+prettyCid(onlyFam)+", matched to the one flag on your profile.","Drinking water only");
    rec.why+=cfgLine(rec.handle,"specialty",cids.indexOf("tthm")>-1);
    alts.push(prod("reverse-osmosis-under-sink-water-filter-1000c","Prefer the broadest coverage in one unit? 12-stage under-sink reverse osmosis.","Broadest coverage"));
    alts.push(prod(onlyFam+"-countertop-water-filter-system","The no-plumbing countertop version of the same treatment.","No plumbing"));
  } else if(health.length){
    rec=prod("reverse-osmosis-under-sink-water-filter-1000c","Your profile carries "+health.slice(0,3).map(prettyCid).join(", ")+": under-sink reverse osmosis is the broad-coverage answer at the tap.","Drinking water only");
    alts.push(prod("countertop-reverse-osmosis-water-filters","Reverse osmosis without opening the cabinet.","No plumbing"));
    /* carbon good-option: offered ONLY when every health flag is in SMART
       media's documented class (PFAS-class chemicals, VOCs, DBPs) - never
       when the mix includes arsenic/nitrate/metals the carbon bed cannot own */
    var CARBON_CLASS={pfoa:1,benzene:1,tthm:1};
    if(health.every(function(c){return CARBON_CLASS[c];})){
      alts.push(prod("smart-under-sink-water-filter-system","The budget-friendly carbon route: SMART media reduces many PFAS-class and chemical contaminants. The reverse osmosis pick above gives the fuller reduction.","Good value, carbon"));
    }
  } else {
    rec=prod("smart-under-sink-water-filter-system","The taste, odor and chlorine class, treated right at the kitchen tap.","Drinking water only");
    rec.why+=cfgLine(rec.handle,"smart",false);
    alts.push(prod("smart-countertop-water-filter-system","No-plumbing countertop version, renter friendly.","No plumbing"));
    alts.push(prod("reverse-osmosis-under-sink-water-filter-1000c","Step up to under-sink RO for the broadest reduction.","Step up"));
    budget.push(prod("water-filter-pitcher","Everyday taste and odor, by the pitcher.","Budget"));
    budget.push(prod("faucet-mount-water-filter-system","Clips straight onto the faucet, six stages in the housing.","Budget"));
  }
  var shower=(cids.indexOf("tthm")>-1)?prod("premium-shower-filter","Chlorine class in your answers: the shower is the one tap an under-sink cannot cover.","Add-on"):null;

  document.getElementById("cqr-h1").textContent = rec.name+" is the right fit for your drinking water.";
  var srcTxt = S.source==="well" ? (S.srcUnsure?"private well (assumed)":"private well")
             : (S.srcUnsure||!S.source) ? "assumed city water" : "city water";
  var chips=['Path: <b>drinking water only</b>',
             'Built from: <b>'+(b.profile.length? b.profile.length+" water factor"+(b.profile.length>1?"s":""):"your answers")+'</b>',
             'Source: <b>'+srcTxt+'</b>'];
  if(S.reportProfile.length) chips.push('Your report: <b>'+S.reportProfile.length+' result'+(S.reportProfile.length>1?'s':'')+'</b>');
  if(S.zipProfile.length && S.source!=="well" && S.zipUtil) chips.push('Public records: <b>'+esc(S.zipUtil.name)+'</b>');
  if(res.severity && res.severity!=="baseline" && b.hasMeasured) chips.push('Overall: <b>'+res.severity+'</b>');
  if(!b.hasMeasured && b.profile.length) chips.push('<span>Recommended from what you told us</span>');
  document.getElementById("cqr-built").innerHTML = chips.map(function(c){return '<li class="cqr-chip">'+c+'</li>';}).join("");

  var recCard = rec; recCard.tier = "Drinking water only";
  /* rec + alternatives share one grid; starters + add-ons share another */
  var html = '<section class="cqr-tiers">'+pouCard(recCard,true)+
    alts.map(function(a){ return pouCard(a,false); }).join("")+'</section>';
  var extras = budget.concat(shower?[shower]:[]);
  if(extras.length) html += '<p class="cqr-sub">'+(budget.length?"Easy starters and add-ons":"Worth adding")+'</p><section class="cqr-tiers">'+
    extras.map(function(a){ return pouCard(a,false); }).join("")+'</section>';
  if(!budget.length && health.length) html += '<p class="cqr-flags-p" style="margin:18px 0 0">We skip pitcher and faucet filters for this water: '+esc(health.slice(0,3).map(prettyCid).join(", "))+' need'+(health.length>1?'':'s')+' more than they can do.</p>';
  var tEl=document.getElementById("cqr-tiers"); tEl.setAttribute("class",""); tEl.innerHTML=html;
  LAST.setupHandles=[]; LAST.condHandles=[]; LAST.anchorIsRo=false; LAST.cfg=null; LAST.off={}; LAST.added={}; LAST.addable=[]; LAST.stageInfo={};
  LAST.cids=cids; LAST.anchorName=rec.name; LAST.anchorHandle=rec.handle;
  /* 2026-08-02: keep the email-capture payload current on the POU view too */
  LAST.res=res; LAST.b=b; LAST.flags=watchFlags(b.seen||{});
  LAST.rationaleHtml='<section class="cqr-rationale"><p class="cqr-flags-h">How we designed this</p>'+
    '<p><b>System selection.</b> '+esc(rec.why)+'</p>'+
    '<p><b>Evidence basis.</b> Built from '+(b.profile.length? b.profile.length+" water factor"+(b.profile.length>1?"s":"")+" in your answers":"your answers")+
    (S.reportProfile.length?', including '+S.reportProfile.length+' measured result'+(S.reportProfile.length>1?'s':'')+' from your report':'')+
    '. Point-of-use systems treat the water you drink and cook with; the whole-home tab covers every tap.</p></section>';
  renderFlags(b);
  finishResult(res, rec, "Point of use");
}

function priceSlot(h, mini, extra){
  return '<div class="cqr-price" data-price-handle="'+esc(h)+'"'+(mini?' data-price-mini="1"':'')+(extra||'')+'>'+
    (mini?'':'<span class="cqr-stageprice">Checking today&#39;s price&hellip;</span>')+'</div>';
}
function imgFor(h){ var r=regRow(h); return (r&&r.img)||""; }
function urlFor(h, fb){ var r=regRow(h); return (r&&r.url)||fb||("https://crystalquest.com/products/"+h); }
/* RATIONALE-SLICE-BEGIN (sliced by verification tooling; reads S, QS, findOpt, esc) */
function stageRole(handle, name, ix, total, carbonBefore){
  var last = ix===total-1;
  var spec = carbonBefore
    ? " sits behind the carbon bed, working on water already stripped of chlorine, which keeps its media healthy and effective"
    : " does its targeted work mid-line, before the polishing stages";
  if(/whole-house-water-softener/.test(handle)) return "the softener "+(ix===0?"leads the line":"sits early")+", softening the water before it touches anything else so scale never reaches the beds behind it";
  if(/salt-free-water-conditioner/.test(handle)) return last
    ? "the salt-free conditioner rides at the end of the line, protecting the plumbing without salt or weekly tending"
    : "the salt-free conditioner sits late in the line, protecting the plumbing without salt, with disinfection following it";
  if(/dosing-system/.test(handle)) return "the dosing stage goes first, oxidizing the heavy load so the filters behind it can actually catch it";
  if(/iron-whole-house|iron-/.test(handle)) return "the metal unit comes early, pulling iron and sulfur out before they can foul the finer stages";
  if(/silica-whole-house/.test(handle)) return "the TrappXT silica bed runs ahead of the carbon stages, catching the one scale-former a softener cannot touch";
  if(/fluoride-whole-house/.test(handle)) return "the fluoride unit"+spec;
  if(/arsenic-whole-house/.test(handle)) return "the arsenic unit"+spec;
  if(/nitrate-whole-house/.test(handle)) return "the nitrate unit"+spec;
  if(/lead-removal-whole-house/.test(handle)) return "the lead unit"+spec;
  if(/tannin-whole-house/.test(handle)) return "the tannin unit clearing the organic color"+spec;
  if(/radium-uranium/.test(handle)) return "the radionuclide unit"+spec;
  if(/sulfate-removal/.test(handle)) return "the sulfate unit"+spec;
  if(/acid-neutralizing/.test(handle)) return "the neutralizer raises the pH early so corrosive water stops eating the plumbing and the stages behind it";
  if(/high-flow|smart-whole-house|eagle-whole-house|whole-house-water-filter-guardian/.test(handle)) return "the carbon bed runs "+(last?"last":"late")+", clearing chlorine, byproducts and taste so every tap finishes clean";
  if(/whole-house-reverse-osmosis/.test(handle)) return "reverse osmosis is the treatment line itself here, with its pre-treatment built in ahead of the membranes";
  if(/ultraviolet-water-sterilizer/.test(handle)) return "UV sits dead last, disinfecting water that is already clear so nothing shades bacteria from the light";
  return name+" carries its stage of the work";
}
function toldUsBits(){
  var bits=[];
  var qn=null, qc=null, qs2=null;
  for(var i=0;i<QS.length;i++){ if(QS[i].k==="notice") qn=QS[i]; if(QS[i].k==="concerns") qc=QS[i]; if(QS[i].k==="surround") qs2=QS[i]; }
  (S.notice||[]).forEach(function(v){
    if(v==="none") return;
    var o=qn&&findOpt(qn,v); if(o) bits.push("the \""+o.n.toLowerCase()+"\"");
  });
  var cnames=(S.concerns||[]).map(function(v){ var o=qc&&findOpt(qc,v); return o?o.n:null; }).filter(Boolean);
  /* sentence-case the worry list without flattening acronyms (PFAS, VOCs) */
  var caseKeep=function(n){ return n.split(" ").map(function(w){ return /^[A-Z0-9]{2,}s?$/.test(w) ? w : w.toLowerCase(); }).join(" "); };
  if(cnames.length) bits.push(cnames.map(caseKeep).join(", ")+" from your worry list");
  if(S.source==="well" && S.wellchlor==="yes") bits.push("the chlorinator on your well");
  if((S.surround||[]).length && qs2){
    var snames=(S.surround||[]).map(function(v){ var o=findOpt(qs2,v)||(qc&&qc.sub&&qc.sub.items.filter(function(x){return x.v===v;})[0]); return o?o.n.toLowerCase():null; }).filter(Boolean);
    if(snames.length) bits.push("what surrounds you ("+snames.join(", ")+")");
  }
  return bits;
}
function buildRationale(res, b, anchor, sizeLine, sizeNote, conds, seq){
  var out=[];
  /* selection */
  var sel = anchor.why||"";
  if(res.config){
    var hp=(b.prov||{}).hardness;
    if(S.configPref && res.config.why && res.config.why.indexOf("Your call")===0){
      sel += " "+res.config.why;
    } else if(res.config.kind==="softener"){
      sel += (hp==="concern"
        ? " You flagged hard water yourself, so we spec true cation-exchange softening rather than guessing around it. Rather skip the salt and the drain line? The salt-free anti-scale swaps straight in above."
        : " The measured hardness here earns a true softener. The salt-free anti-scale is the swap if you want zero upkeep.");
    } else {
      /* AJ 2026-07-29: city + explicit concern now defaults anti-scale, so the
         conditioner rationale must not claim "scale signs" they never reported */
      sel += (hp==="concern"
        ? " You flagged hard water, and on city supply hardness usually sits in the moderate range, so we spec the salt-free anti-scale: zero upkeep, pipes and appliances protected. Want the true soft-water feel instead? The softener swaps straight in above."
        : " We saw scale signs but no measured number, so the salt-free conditioner is the low-regret call: it protects pipes and appliances with no salt and no drain line, and a simple hardness test can justify the full softener later.");
    }
  }
  out.push("<b>Why this system.</b> "+sel);
  /* order - generated from the ACTUAL sequence, only when there is one */
  if(seq && seq.length>=2){
    var carbonIdx=-1;
    seq.forEach(function(it,ix){ if(carbonIdx<0 && /high-flow|smart-whole-house|eagle-whole-house|whole-house-water-filter-guardian/.test(it.handle)) carbonIdx=ix; });
    var roles=seq.map(function(it,ix){ return stageRole(it.handle, it.name, ix, seq.length, carbonIdx>-1 && carbonIdx<ix); });
    out.push("<b>Why this order.</b> "+roles[0].charAt(0).toUpperCase()+roles[0].slice(1)+"; "+roles.slice(1).join("; ")+". That order is deliberate: each stage hands the next one cleaner water, so the media downstream works less and lasts longer.");
  }
  /* sizing - from the actual answers */
  var szBits=[];
  if(S.people) szBits.push((({"2":"1 to 2","4":"3 to 4","6":"5 to 6","8":"7 or more"})[S.people])+" people");
  if(S.baths) szBits.push(S.baths+" bathrooms");
  var szWhy;
  if((res.sizing||{}).ro) szWhy = "Whole-house reverse osmosis is sized in daily gallons plus storage: "+esc(sizeLine)+" for "+ (szBits.join(" and ")||"your home") +".";
  else if(sizeLine.indexOf("High Flow")===0){
    var dNames=(S.demand||[]).filter(function(d){return d!=="none";}).map(function(d){
      return ({simul:"simultaneous showers",irrigation:"irrigation draw",pool:"pool fills"})[d];
    }).filter(Boolean);
    szWhy = esc(sizeLine)+": "+(szBits.join(" and ")||"your bathroom count")+(dNames.length?" plus "+dNames.join(" and "):"")+" put you past what a standard tank flows without a pressure drop.";
  }
  else if(sizeLine.indexOf("1.5")===0) szWhy = esc(sizeLine)+" for "+(szBits.join(" and ")||"your home")+": full pressure without paying for capacity you will not use. The 2.0 is the headroom upgrade if the household grows.";
  else szWhy = esc(sizeLine)+" for "+(szBits.join(" and ")||"your home")+": enough bed to hold full pressure for a household this size, with headroom to spare.";
  out.push("<b>Sizing.</b> "+szWhy);
  /* evidence - echo their own words */
  var bits=toldUsBits(), ev;
  if(S.reportProfile.length||((S.zipProfile||[]).length&&S.source!=="well"&&S.zipUtil)){
    var m=[];
    if(S.reportProfile.length) m.push(S.reportProfile.length+" measured result"+(S.reportProfile.length>1?"s":"")+" from your report");
    if((S.zipProfile||[]).length&&S.source!=="well"&&S.zipUtil) m.push("your utility&#39;s public record ("+esc(S.zipUtil.name)+")");
    ev = "This design stands on "+m.join(" and ")+(bits.length?", alongside "+bits.join(", ")+".":".");
  } else if(bits.length){
    ev = "We built this around what you told us: "+bits.join(", ")+". Nothing here is a lab number yet: a quick water test either confirms this build or tells us exactly what to change.";
  } else {
    ev = "You did not report problems, so this is baseline protection done properly rather than treatment for a diagnosis.";
  }
  out.push("<b>What went into it.</b> "+ev);
  /* held for a test */
  if(conds && conds.length) out.push("<b>What we held back.</b> "+conds.map(function(c){return esc(c.name);}).join(", ")+": your situation points that way, and a quick test is how we make sure before you spend. Add any of them yourself if you would rather have it handled now.");
  return '<section class="cqr-rationale"><p class="cqr-flags-h">How we designed this</p>'+
    out.map(function(t){ return '<p>'+t+'</p>'; }).join("")+'</section>';
}
/* RATIONALE-SLICE-END */
function paintPrices(){
  var nodes=document.querySelectorAll("[data-price-handle]");
  var handles={};
  for(var i=0;i<nodes.length;i++){
    handles[nodes[i].getAttribute("data-price-handle")]=1;
    var fbh=nodes[i].getAttribute("data-price-fallback"); if(fbh) handles[fbh]=1;
  }
  function maybeTotal(){
    var hs=LAST.setupHandles||[], sum=0, anyFrom=false;
    for(var j=0;j<hs.length;j++){
      if(stageOff(hs[j])) continue; /* removed in the build editor */
      if(!cache.prices[hs[j]]) return;
      var rec=resolveVariant(hs[j]) || cache.prices[hs[j]];
      if(!rec || rec.price==null) return;
      sum+=rec.price; if(!rec.exact) anyFrom=true;
    }
    /* AJ 2026-08-03: the build total is the BUNDLED price - the combined
       anchor variant where one exists, the standalone add-on otherwise */
    if(LAST.cfg && !stageOff(LAST.cfg.fallback)){
      var rcT=resolveVariant(LAST.cfg.anchor, LAST.cfg.kind);
      var raT=resolveVariant(LAST.cfg.anchor, null);
      if(rcT && rcT.cfgMatched && rcT.exact && raT && raT.exact && rcT.price>raT.price){
        sum += rcT.price-raT.price;
      } else {
        if(!cache.prices[LAST.cfg.fallback]) return;
        var rfT=resolveVariant(LAST.cfg.fallback);
        if(!rfT || rfT.price==null) return;
        sum += rfT.price; if(!rfT.exact) anyFrom=true;
      }
    }
    /* optional additions the customer switched on join the total */
    var adds2=LAST.addable||[];
    for(var a3=0;a3<adds2.length;a3++){
      var ah2=adds2[a3].handle;
      if(!stageAdded(ah2)) continue;
      if(!cache.prices[ah2]) return;
      var ar2=resolveVariant(ah2);
      if(!ar2 || ar2.price==null) return;
      sum+=ar2.price; if(!ar2.exact) anyFrom=true;
    }
    var edited = (LAST.off && Object.keys(LAST.off).some(function(k){ return LAST.off[k]; }))
              || (LAST.added && Object.keys(LAST.added).some(function(k){ return LAST.added[k]; }));
    var lbl2 = (LAST.cfg && !stageOff(LAST.cfg.fallback)) ? "your full build, bundled for best value" : "your build total";
    if(edited) lbl2 = "your build, as you edited it";
    var t=document.getElementById("cqr-btotal");
    if(t && hs.length) t.innerHTML='<span class="cqr-bnow">'+(anyFrom?"from ":"")+money(sum)+'</span><span class="cqr-bandlbl" style="margin-left:10px">'+lbl2+'</span>';
    /* the sticky bar speaks for the BUILD, not one product, once priced */
    var ss=document.getElementById("cqr-ssub");
    if(ss && hs.length>1) ss.textContent="Your build total: "+(anyFrom?"from ":"")+money(sum);
    var cds=LAST.condHandles||[];
    if(cds.length){
      var csum=sum, ok=true, cfrom=anyFrom;
      for(var k=0;k<cds.length;k++){
        if(stageAdded(cds[k])) continue; /* already in the core sum via the checkbox */
        if(!cache.prices[cds[k]]){ ok=false; break; }
        var cr=resolveVariant(cds[k]) || cache.prices[cds[k]];
        if(!cr || cr.price==null){ ok=false; break; }
        csum+=cr.price; if(!cr.exact) cfrom=true;
      }
      var ct=document.getElementById("cqr-ctotal");
      /* suppressed when every cond is checked (it would repeat the total) */
      if(ct) ct.innerHTML = (ok && csum>sum)
        ? '<span class="cqr-bnow" style="font-size:22px">'+(cfrom?"from ":"")+money(csum)+'</span><span class="cqr-bandlbl" style="margin-left:10px">complete build, including the test-to-confirm stages</span>'
        : '';
    }
    /* cost crossover: when the multi-system build prices past whole-house RO,
       say so and offer the one-system path */
    if(!LAST.anchorIsRo && hs.length>1){
      fetchPrice("whole-house-reverse-osmosis-system").then(function(ro){
        var x=document.getElementById("cqr-crossover");
        if(!x || !ro || ro.price==null) return;
        var roR=resolveVariant("whole-house-reverse-osmosis-system");
        if(roR && roR.price!=null) ro=roR;
        var csum2=null;
        if(cds.length){
          csum2=sum;
          for(var m=0;m<cds.length;m++){ if(stageAdded(cds[m])) continue; if(!cache.prices[cds[m]]){ csum2=null; break; } var crm=resolveVariant(cds[m])||cache.prices[cds[m]]; if(!crm||crm.price==null){ csum2=null; break; } csum2+=crm.price; }
        }
        var link=' <a href="'+urlFor("whole-house-reverse-osmosis-system")+'" target="_blank" rel="noopener" style="color:#fff;font-weight:700">Compare the RO route</a>';
        if(sum>ro.price){
          x.innerHTML='<div class="cqr-bandnote" style="display:block;margin-top:12px;padding:12px 14px">Worth a look: this multi-system build prices '+(anyFrom?"from ":"")+money(sum)+', and a whole-house reverse osmosis system from '+money(ro.price)+' treats this entire profile in one system.'+link+'</div>';
        } else if(csum2!==null && csum2>ro.price){
          x.innerHTML='<div class="cqr-bandnote" style="display:block;margin-top:12px;padding:12px 14px">Planning ahead: if testing confirms every held stage, the complete build prices from '+money(csum2)+'. A whole-house reverse osmosis system from '+money(ro.price)+' would cover the same profile in one system, worth weighing before you commit.'+link+'</div>';
        }
      }).catch(function(){});
    }
  }
  /* per-element paint: resolve the exact variant where the recommendation
     pins one; config slots try the anchor's combined variant first and fall
     back to the standalone configuration product */
  function paintOne(el){
    var h=el.getAttribute("data-price-handle");
    var cfg=el.getAttribute("data-price-cfg")||null;
    var fb=el.getAttribute("data-price-fallback")||null;
    var r=resolveVariant(h, cfg);
    if(cfg && r && r.cfgMatched){
      /* AJ 2026-08-03 round 2: the card is about the ADD-ON, so the price
         must read as the add-on's: its own standalone price struck through,
         then what it effectively costs inside the combined build (combined
         minus the anchor), then the saving. The bundle total rides as a
         quiet caption so the hero + this card never look like they sum. */
      var ra=resolveVariant(h, null);
      var rs=fb ? resolveVariant(fb, null) : null;
      var delta=(r.exact && ra && ra.exact && r.price>ra.price) ? r.price-ra.price : null;
      /* review fix 2026-08-03: chip, card and total must always agree.
         delta known -> everything speaks in-bundle delta; delta unknown ->
         everything falls back to the STANDALONE add-on price (which is what
         maybeTotal charges in that case) - never an unnumbered "bundled". */
      if(el.getAttribute("data-price-mini")){
        if(delta!==null) el.innerHTML='<span class="cqr-stageprice">+ '+money(delta)+' in the bundle</span>';
        else if(rs && rs.price!=null) el.innerHTML='<span class="cqr-stageprice">'+(rs.exact?"":"from ")+money(rs.price)+'</span>';
        return;
      }
      /* the was/save comparison only holds when the standalone fallback is
         the same size class; High Flow has no standalone comparator, so it
         speaks pure in-bundle delta (AJ 2026-08-03) */
      if(delta!==null && rs && rs.exact && rs.price>delta && h.indexOf("high-flow")<0){
        el.innerHTML='<span class="cqr-was">'+money(rs.price)+'</span><span class="cqr-now">'+money(delta)+'</span>'+
          '<span class="cqr-save">Save '+money(rs.price-delta)+' when added as the combined build</span>'+
          '<span class="cqr-pricecap" style="width:100%">'+money(r.price)+' total for both systems together</span>';
        return;
      }
      if(delta!==null){
        el.innerHTML='<span class="cqr-now">+ '+money(delta)+'</span>'+
          '<span class="cqr-pricecap">added in the combined build ('+money(r.price)+' total)</span>';
        return;
      }
      if(rs && rs.price!=null){
        el.innerHTML='<span class="cqr-now">'+(rs.exact?"":"from ")+money(rs.price)+'</span>';
        return;
      }
      el.innerHTML='<span class="cqr-now">'+(r.exact?"":"from ")+money(r.price)+'</span>'+
        '<span class="cqr-pricecap">for the combined build</span>';
      return;
    }
    if(cfg && fb && cache.prices[fb]) r=resolveVariant(fb);
    if(!r || r.price==null){ el.innerHTML='<span class="cqr-stageprice">See price on the product page</span>'; return; }
    el.innerHTML = el.getAttribute("data-price-mini")
      ? '<span class="cqr-stageprice">'+(r.exact?"":"from ")+money(r.price)+'</span>'
      : '<span class="cqr-now">'+(r.exact?"":"from ")+money(r.price)+'</span>';
  }
  function paintAll(){
    var els=document.querySelectorAll("[data-price-handle]");
    for(var i=0;i<els.length;i++){
      var h=els[i].getAttribute("data-price-handle");
      var fb=els[i].getAttribute("data-price-fallback");
      if(cache.prices[h] && (!fb || cache.prices[fb])) paintOne(els[i]);
    }
    /* deep-link CTAs to the resolved variant so the product page opens
       preconfigured (real add-to-cart arrives with crystalquest.com hosting) */
    var as=document.querySelectorAll("a[data-vh]");
    for(var k=0;k<as.length;k++){
      var a=as[k], vh=a.getAttribute("data-vh"), vcfg=a.getAttribute("data-vcfg")||null;
      if(!cache.prices[vh]) continue;
      var rv=resolveVariant(vh, vcfg);
      if(vcfg && rv && rv.cfgMatched && rv.id) a.href=urlFor(vh)+"?variant="+rv.id;
      else if(!vcfg && rv && rv.exact && rv.id) a.href=urlFor(vh)+"?variant="+rv.id;
    }
    var ab=document.getElementById("cqr-addbuild");
    if(ab && !ab.onclick){
      var bi=buildCartItems();
      ab.hidden = !bi;
      /* the same build never adds twice: a re-render after a successful add
         comes back already in the added state */
      if(bi && CART_ADDED_SIG && cartSig(bi)===CART_ADDED_SIG){
        ab.textContent="Added ✓ open your cart";
        ab.onclick=function(){ window.location.href="/cart"; };
      }
    }
  }
  var pending=Object.keys(handles).length;
  Object.keys(handles).forEach(function(h){
    fetchPrice(h).then(function(){
      pending--; paintAll(); maybeTotal();
    }).catch(function(){
      pending--;
      var els=document.querySelectorAll('[data-price-handle="'+h+'"]');
      for(var i=0;i<els.length;i++){
        if(els[i].getAttribute("data-price-fallback")) continue;
        els[i].innerHTML='<span class="cqr-stageprice">See price on the product page</span>';
      }
    });
  });
}
function showResult(){
  /* immutable unsure-source sentinel (Sol caution 2026-07-29): set once at the
     first result render, survives the source-view toggle, cleared by restart */
  if(S.srcUnsure===undefined) S.srcUnsure=(S.source!=="city"&&S.source!=="well");
  /* ---- ONE call to the real engine. No hand-written per-scenario copy. ---- */
  var b = buildProfile();
  var res;
  try{
    /* every buildProfile ctx flag flows through (two flags were silently
       dropped by an older hand-copied list - never again); the IIFE keeps
       the whole call self-contained for the sweep's extracted span */
    res = CQPresent.present(b.profile, (function(){
      var cx={}; for(var ck in b.ctx) cx[ck]=b.ctx[ck];
      cx.source = S.source==="unsure" ? "city" : (S.source||"city");
      cx.people = S.people || undefined;
      cx.baths  = S.baths  || undefined;
      cx.provenance = b.prov;
      return cx;
    })(), ENGINE_DATA);
  }catch(e){
    res = null;
  }
  /* opus verify D1 (2026-08-03): reset the build-edit state BEFORE any card
     is built - cards render their checkboxes from this state, and the old
     late reset let them paint the PREVIOUS build's checks then wiped it */
  LAST.off = {};
  LAST.added = {};
  if(!res || !res.primary){
    LAST.res=null; LAST.b=b; LAST.flags=[];
    var kitH = S.source==="well" ? "well-water-test" : "city-water-test";
    document.getElementById("cqr-h1").textContent = "We need a closer look at your water.";
    document.getElementById("cqr-built").innerHTML =
      '<li class="cqr-chip">Your answers did not give us enough to size a system safely</li>';
    var tEl0=document.getElementById("cqr-tiers"); tEl0.setAttribute("class",""); tEl0.innerHTML="";
    document.getElementById("cqr-band").innerHTML =
      '<p class="cqr-band-eyebrow">Next step</p><h2 class="cqr-band-h">A water test settles this in one go</h2>'+
      '<p class="cqr-band-p">Rather than guess, we would rather measure. A test kit gives us the numbers to design the right system.</p>'+
      '<div class="cqr-bandbuy"><a class="cqr-bandbtn" style="text-decoration:none" href="'+urlFor(kitH)+'" target="_blank" rel="noopener">Order a water test kit</a></div>';
    LAST.setupHandles=[]; LAST.condHandles=[]; LAST.cfg=null; LAST.off={}; LAST.added={}; LAST.addable=[]; LAST.stageInfo={};
    finishResult(null); return;
  }

  /* AJ 2026-07-28: when the softener-vs-anti-scale choice is PREFERENCE
     territory (nothing measured requires true softening), the customer picks
     the life that fits: soft-water feel with salt upkeep, or zero-maintenance
     anti-scale. A measured need locks the softener. */
  var cfgLocked = false;
  if(res.config){
    var hpv=(b.prov||{}).hardness;
    cfgLocked = (hpv==="report"||hpv==="records") && res.config.kind==="softener";
    if(!cfgLocked && S.configPref && S.configPref!==res.config.kind){
      var prefH = S.configPref==="softener" ? "whole-house-water-softener" : "salt-free-water-conditioner";
      var prefR = regRow(prefH) || {};
      res.config = { handle: prefH, kind: S.configPref,
        name: prefR.name || (S.configPref==="softener"?"Whole House Water Softener":"Salt-Free Water Conditioner"),
        url: prefR.url || ("https://crystalquest.com/products/"+prefH),
        why: S.configPref==="softener"
          ? "Your call: you want the true soft-water feel, so we spec the full cation-exchange softener. Budget for salt bags and a drain line; that is the trade for truly soft water."
          : "Your call: you want minimal upkeep, so we spec the salt-free anti-scale. No salt bags, no drain line, no weekly tending, and it protects the plumbing without changing how the water feels." };
    }
  }
  if(!S.view) S.view = (S.scope==="pou") ? "pou" : "whole";
  if(!S._doneTracked){ S._doneTracked=true; cqTrack("quiz_complete",{scope:S.scope||"",view:S.view}); }
  renderScopeToggle();
  if(S.view==="pou"){ renderPou(b,res); return; }
  document.getElementById("cqr-band").style.display="";

  var sizing = res.sizing || {};
  /* CQ rates standard tanks by HOUSEHOLD SIZE (SMART 9-13 GPM = 4-6 people) and
     High Flow by BATHROOMS + peak demand. Different axes, so we read both.
     Default is the 2.0 cu ft tank; we only step up on real extra demand. */
  var demand = S.demand || [];
  var bigDemand = demand.indexOf("simul")>-1 || demand.indexOf("irrigation")>-1 || demand.indexOf("pool")>-1;
  var manyBaths = (S.baths === "5+");
  var midBaths  = (S.baths === "3-4");
  var pick;
  if(manyBaths && bigDemand)      pick = {label:"High Flow, 35 GPM", note:"Sized for 6+ bathrooms with heavy simultaneous draw."};
  else if(manyBaths)              pick = {label:"High Flow, 20 GPM", note:"Sized for a 5+ bathroom home."};
  else if(midBaths && bigDemand)  pick = {label:"High Flow, 15 GPM", note:"Your bathroom count is mid-range, but the extra draw pushes it up a size."};
  else if(S.baths === "1-2" && !bigDemand && (S.people === "2" || S.people === "4" || !S.people))
                                  pick = {label:"1.5 cu ft tank", note:"Normal use on 1 to 2 bathrooms, so the 1.5 covers it comfortably; the 2.0 is the headroom upgrade."};
  else                            pick = {label:"2.0 cu ft tank", note:"The size that suits most homes, with headroom to spare."};
  var sizeLine = sizing.ro ? sizing.ro : pick.label;
  var sizeNote = sizing.ro ? "" : pick.note;

  /* v4: when sizing lands in High Flow territory the ANCHOR CARD is the High
     Flow build itself, so the size line and the product never disagree. */
  var anchor = { handle: res.primary.handle, name: res.primary.name,
                 url: urlFor(res.primary.handle, res.primary.url), why: res.primary.why };
  /* AJ 2026-08-03: the family ladder is SELECTABLE - a chosen tier becomes
     the anchor (cards, band, totals, cart all follow via the existing
     anchor-swap machinery); the High Flow sizing swap still wins at 5+ */
  if(S.anchorPref && res.choice && res.choice.length>=2){
    for(var apx=0;apx<res.choice.length;apx++){
      var apc=res.choice[apx];
      if(apc.handle===S.anchorPref && apc.handle!==res.primary.handle){
        anchor = { handle: apc.handle, name: apc.name,
                   url: urlFor(apc.handle, apc.url), why: apc.blurb || res.primary.why };
        break;
      }
    }
  }
  /* media Type for HF resolution follows the CUSTOMER's tier pick -
     captured as a local here (this block runs inside the sweep sandbox);
     assigned onto LAST after the slice boundary below */
  var hfMediaPick = /eagle/i.test(anchor.handle) ? "eagle" : "smart";
  var isHF = !!sizing.upgrade || pick.label.indexOf("High Flow")===0;
  if(isHF && !sizing.ro &&
     (anchor.handle==="smart-whole-house-water-filter" || anchor.handle==="eagle-whole-house-water-filter")){
    var hfRow = regRow("high-flow-whole-house-water-filter");
    if(hfRow){
      anchor = { handle: hfRow.handle, name: hfRow.name || "High Flow Whole House Filter",
                 url: hfRow.url, why: res.primary.why };
      sizeNote = "The High Flow build of the same filtration, in your choice of SMART or Eagle media.";
    }
  }

  LAST.cids=(b.profile||[]).map(function(e){return e.canonical_id;});
  LAST.hfType = hfMediaPick;
  LAST.anchorName=anchor.name; LAST.anchorHandle=anchor.handle;
  /* the full setup sequence, with the configuration spliced where it actually
     installs: a salt softener leads the line (after dosing/iron only), a
     salt-free conditioner rides at the end */
  var items=(res.ideal&&res.ideal.items)||[];
  var seq = items.map(function(it){ return {handle:it.handle, name:it.name, price:true, tag:null}; });
  if(res.config && !seq.some(function(it){ return it.handle===res.config.handle; })){
    /* AJ 2026-08-03: the configuration chip carries its own price (the
       add-on's effective cost inside the combined build) like every stage */
    var cfgEntry={handle:res.config.handle, name:res.config.name, price:"cfg", tag:"as the anchor&#39;s configuration"};
    if(res.config.kind==="softener"){
      var at=0; while(at<seq.length && /dosing|iron-/.test(seq[at].handle)) at++;
      seq.splice(at,0,cfgEntry);
    } else {
      var uvAt=-1;
      seq.forEach(function(it,ix){ if(uvAt<0 && /ultraviolet-water-sterilizer/.test(it.handle)) uvAt=ix; });
      if(uvAt>-1) seq.splice(uvAt,0,cfgEntry); else seq.push(cfgEntry);
    }
  }
  /* review fix 2026-08-03: when the engine already carries the config
     product as a stage in ideal.items (strontium-class profiles, or a seg
     swap onto an in-items handle), the combined-variant framing must stand
     DOWN everywhere - card, chip, total and cart all price it as the plain
     stage it is, or the softener gets counted twice */
  var cfgDup = !!(res.config && items.some(function(it){ return it.handle===res.config.handle; }));
  var multiStage = seq.length>=2;
  /* 2026-08-02: when sizing swapped the anchor card to the High Flow build,
     the stage band, rationale and totals must name and price the same unit,
     never the SMART/Eagle tank the engine emitted */
  if(anchor.handle!==res.primary.handle){
    seq = seq.map(function(it){
      return it.handle===res.primary.handle
        ? {handle:anchor.handle, name:anchor.name, price:it.price, tag:it.tag}
        : it;
    });
  }

  document.getElementById("cqr-h1").textContent =
    (res.consolidated ? "One system, sized to treat everything we found at every tap."
                      : anchor.name + (multiStage ? " is the right start for your water." : " is the right core system for this water."));

  var srcTxt = S.source==="well" ? (S.srcUnsure?"private well (assumed)":"private well")
             : (S.srcUnsure||!S.source) ? "assumed city water" : "city water";
  var chips = ['Based on <b>'+(b.profile.length ? b.profile.length+" thing"+(b.profile.length>1?"s":"")+" in your water" : "your answers")+'</b>',
               'Source: <b>'+srcTxt+'</b>'];
  if(S.reportProfile.length) chips.push('Your report: <b>'+S.reportProfile.length+' result'+(S.reportProfile.length>1?'s':'')+'</b>');
  if(S.zipProfile.length && S.source!=="well" && S.zipUtil) chips.push('Public records: <b>'+esc(S.zipUtil.name)+'</b>');
  if(S.baths) chips.push('Sized for <b>'+S.baths+' baths</b>');
  chips.push('Size: <b>'+sizeLine+'</b>');
  /* severity shows ONLY with measured (report/records) provenance, and
     "baseline" is never worn as a badge (it reads as "safe", which we cannot say) */
  if(res.severity && res.severity!=="baseline" && b.hasMeasured)
    chips.push('Overall: <b>'+res.severity+'</b>');
  if(!b.hasMeasured && b.profile.length)
    chips.push('<span style="opacity:.85">Recommended from what you told us</span>');
  if(sizeNote) chips.push('<span>'+sizeNote+'</span>');
  document.getElementById("cqr-built").innerHTML =
    chips.map(function(c){return '<li class="cqr-chip">'+c+'</li>';}).join("");

  /* ---- ROW 1 (AJ 2026-07-29 + Sol-converged): the three decision slots,
     always - crowned hero (+ its configuration card when one exists), the
     purity/media alternative, and the drinking-water-only option. Companions
     moved to the "Complete this setup" row below; the old generic-RO
     link-line demotion is superseded by this row (AJ 2026-07-29). ---- */
  /* AJ 2026-08-03: addons (dosing pre-treatment, UV) join the setup row as
     real cards - the engine emitted them with why copy that never rendered */
  var comps = (res.companions||[]).concat(res.addons||[]);
  var seenComp={};
  comps = comps.filter(function(c){ if(!c || !c.handle || seenComp[c.handle]) return false; seenComp[c.handle]=1; return true; });
  var altCard = "";
  /* AJ 2026-08-03: the RO alternative CARD retired - the Maximum purity (RO)
     view toggle owns that path now; media alternatives (microplastics
     SMART etc.) keep their card */
  if(res.alternative && res.alternative.handle!=="whole-house-reverse-osmosis-system"){
    var roAlt = res.alternative.handle==="whole-house-reverse-osmosis-system";
    var roAltSize = roAlt && res.sizing && res.sizing.ro_alt
      ? '<p class="cqr-size">Sized for your home: '+esc(res.sizing.ro_alt)+'</p>' : '';
    altCard = '<article class="cqr-card"><p class="cqr-tierlabel">'+(roAlt?"Maximum purity":"Media alternative")+'</p>'+
      '<div class="cqr-plate">'+(imgFor(res.alternative.handle)?'<img loading="lazy" src="'+imgFor(res.alternative.handle)+'" alt="'+esc(res.alternative.name)+'">':'')+'</div>'+
      '<h3 class="cqr-name">'+esc(res.alternative.name)+'</h3>'+roAltSize+priceSlot(res.alternative.handle)+
      '<ul class="cqr-why"><li>'+(res.alternative.why||"Reverse osmosis at every tap, the broadest reduction we build.")+'</li></ul>'+
      (roAlt?'<p class="cqr-good"><b>Good to know:</b> Includes the storage tank; needs a drain line and more space than a media tank.</p>':'')+
      '<div class="cqr-actions"><a class="cqr-btn cqr-btn--ghost" href="'+urlFor(res.alternative.handle,res.alternative.url)+'" target="_blank" rel="noopener">Compare this option</a></div></article>';
  }

  /* the configuration always renders as its own card beside the hero when one
     exists (AJ approved the side-by-side; it joins the decision slots, never
     replaces one - Sol R4 2026-07-29) */
  /* AJ 2026-08-03: one even segmented row, never stacked pills; the card's
     why copy already explains the soft-feel vs zero-upkeep trade */
  var toggleChips = (res.config && !cfgLocked)
    ? '<div class="cqr-seg" role="group" aria-label="Choose salt softener or salt-free">'+
      '<button type="button" class="cqr-seg-btn'+(res.config.kind==="softener"?' is-on':'')+'" data-cfgpref="softener">Salt softener</button>'+
      '<button type="button" class="cqr-seg-btn'+(res.config.kind==="conditioner"?' is-on':'')+'" data-cfgpref="conditioner">Salt-free</button></div>'
    : '';
  var cfgCard = "";
  if(res.config){
    /* AJ 2026-08-03: the combined configuration is a real VARIANT on the
       anchor product (live-verified axis) - price and link that variant;
       the standalone configuration product is the fallback */
    /* AJ 2026-08-03: on a High Flow anchor the combined configuration IS an
       HF variant - show the HF system, never the residential add-on's image */
    var cfgImg = anchor.handle.indexOf("high-flow")>-1 ? imgFor(anchor.handle) : imgFor(res.config.handle);
    cfgCard = '<article class="cqr-card cqr-card--with"><p class="cqr-tierlabel">Pairs with your system</p>'+
      '<div class="cqr-plate">'+(cfgImg?'<img loading="lazy" src="'+cfgImg+'" alt="'+esc(res.config.name)+'">':'')+'</div>'+
      '<h3 class="cqr-name">With '+esc(res.config.name)+'</h3>'+
      (cfgDup ? priceSlot(res.config.handle)
              : priceSlot(anchor.handle, false, ' data-price-cfg="'+esc(res.config.kind)+'" data-price-fallback="'+esc(res.config.handle)+'"'))+
      '<ul class="cqr-why"><li>'+esc(res.config.why)+(/costs less than buying/.test(res.config.why||"")?"":" The combined build costs less than buying the two separately.")+'</li></ul>'+
      toggleChips+
      '<label class="cqr-check"><input type="checkbox" data-bcheck="'+esc(res.config.handle)+'" data-bkind="off"'+(stageOff(res.config.handle)?'':' checked')+'> In my build</label>'+
      '<div class="cqr-actions"><a class="cqr-btn cqr-btn--ghost"'+(cfgDup?' data-vh="'+esc(res.config.handle)+'"':' data-vh="'+esc(anchor.handle)+'" data-vcfg="'+esc(res.config.kind)+'"')+' href="'+urlFor(res.config.handle,res.config.url)+'" target="_blank" rel="noopener">View this configuration</a></div></article>';
  }

  /* what ships in the box: engine res.includes, structured {name, optional} */
  var incHtml = "";
  if(res.includes && res.includes.length){
    incHtml = '<div class="cqr-inc"><b>What is included</b><ul>'+res.includes.map(function(r){
      return '<li>'+esc(r.name)+(r.optional?' <span class="cqr-inc-opt">optional add-on</span>':'')+'</li>';
    }).join("")+'</ul></div>';
  }

  var heroCard = '<article class="cqr-card cqr-card--rec">'+
    '<span class="cqr-ribbon">'+(multiStage?"Start here":"Our pick for this water")+'</span>'+
    '<p class="cqr-tierlabel">Whole house</p>'+
    '<div class="cqr-plate">'+(imgFor(anchor.handle)?'<img src="'+imgFor(anchor.handle)+'" alt="'+esc(anchor.name)+'">':'')+'</div>'+
    '<h3 class="cqr-name">'+esc(anchor.name)+'</h3>'+
    '<p class="cqr-size">'+esc(sizeLine)+'</p>'+
    priceSlot(anchor.handle)+
    '<ul class="cqr-why"><li>'+(anchor.why||"")+'</li></ul>'+
    '<p class="cqr-good"><b>Good to know:</b> Sized on your answers, using the same design rules our water specialists work from. Want a second set of eyes? A specialist will gladly confirm this build before you order.</p>'+
    '<label class="cqr-check cqr-check--locked"><input type="checkbox" checked disabled> In my build</label>'+
    '<div class="cqr-actions"><a class="cqr-btn cqr-btn--solid cqr-btn--lg" data-vh="'+esc(anchor.handle)+'" href="'+anchor.url+'" target="_blank" rel="noopener">Configure this system</a>'+
    '<a class="cqr-btn cqr-btn--ghost" href="'+anchor.url+'" target="_blank" rel="noopener">View details</a></div></article>';

  /* AJ 2026-08-03 (supersedes the 07-29 fourth slot): the drinking-water-only
     card is GONE from the whole-house view - the Drinking water only tab and
     the band's polish line already carry that option; the card was redundant
     space. res.pou still feeds both of those. */
  var pouCardTop = "";

  /* AJ 2026-07-29: never more than 3 cards in the first display - the
     overflow (usually the drinking-only card) flows into its own row below,
     same card styling, priority order hero > config > alternative > pou */
  var row1Cards = [heroCard, cfgCard, altCard, pouCardTop].filter(function(x){ return !!x; });
  var heroHtml = "";
  for(var rc=0; rc<row1Cards.length; rc+=3){
    /* AJ 2026-08-03: with a full 3-card row the start-here card holds the
       CENTER and reads slightly larger (cqr-tiers--hero3) */
    var rowCls = (!rc && row1Cards.length===3) ? ' cqr-tiers--hero3' : '';
    heroHtml += '<section class="cqr-tiers'+rowCls+(rc?' cqr-tiers--flow" style="margin-top:18px':'')+'">'+row1Cards.slice(rc,rc+3).join("")+'</section>';
  }
  /* verified trust claims at the money moment (red-line-safe set only) */
  /* AJ 2026-08-03: the trust strip moves BELOW the tier ladder so the
     swap-your-tier row sits directly against the system it swaps */
  var trustHtml = '<p class="cqr-trust"><span><b>Over 1,000,000 people served</b> since 1994</span>'+
    '<span>ISO 9001 certified manufacturer</span>'+
    '<span>Backed by our <a href="https://crystalquest.com/pages/our-guaranteed-performance" target="_blank" rel="noopener">Guaranteed Performance program</a></span>'+
    '<span>Built on 30+ years of water treatment know-how</span></p>';
  var compHtml = "";

  /* ---- FAMILY ladder: only when the engine emits a genuine same-class choice ---- */
  var famHtml = "";
  if(res.choice && res.choice.length>=2 && !isHF){
    var nTier = res.choice.length;
    /* AJ 2026-08-03: no literal Good/Better/Best wording - each tier wears
       the words that actually describe it (the ladder order still tells the
       story); Eagle's premium hook is its alkalizing mineral blend */
    var tierLabel = function(c){
      var t=c.tier;
      if(t==="budget") return "Essential &middot; cost efficient";
      if(t==="standard") return "Broad everyday coverage";
      if(t==="premium") return /eagle/.test(c.handle||"") ? "Premium &middot; enhanced alkalinity" : "Premium coverage";
      return t||"";
    };
    var TIER_RANK={budget:1,standard:2,premium:3};
    var ladder=res.choice.slice().sort(function(a,b){ return (TIER_RANK[a.tier]||2)-(TIER_RANK[b.tier]||2); });
    /* AJ 2026-08-03: the ladder announces itself as the SWAP row for the
       main system, and names the trade each tier makes */
    var _tf=[];
    if(ladder.some(function(c){return c.tier==="budget";})) _tf.push("essentials for cost efficiency");
    if(ladder.some(function(c){return c.tier==="premium" && /eagle/.test(c.handle||"");})) _tf.push("premium for enhanced mineral content");
    else if(ladder.some(function(c){return c.tier==="premium";})) _tf.push("premium for the fullest coverage");
    famHtml = '<p class="cqr-sub">Your main system, '+(nTier===3?"three":"two")+' ways</p>'+
      '<p class="cqr-subnote">Each of these swaps in for the '+esc(anchor.name)+' as your start-here system'+(_tf.length?': '+_tf.join(', '):'')+'. Your build and total follow whichever you pick.</p>'+
      '<section class="cqr-tiers">'+
      ladder.map(function(c){
        var crowned = c.handle===anchor.handle;
        return '<article class="cqr-card'+(crowned?' cqr-card--rec':'')+'">'+
          (crowned?'<span class="cqr-ribbon">'+(c.handle===res.primary.handle?"Our pick":"Your pick")+'</span>':'')+
          '<p class="cqr-tierlabel">'+tierLabel(c)+'</p>'+
          '<div class="cqr-plate">'+(imgFor(c.handle)?'<img src="'+imgFor(c.handle)+'" alt="'+esc(c.name)+'">':'')+'</div>'+
          '<h3 class="cqr-name">'+esc(c.name)+'</h3>'+
          '<p class="cqr-size">'+esc(c.blurb||"")+'</p>'+priceSlot(c.handle)+
          '<div class="cqr-actions">'+(crowned
            ? '<button class="cqr-btn cqr-btn--ghost" type="button" data-scrolltop>Shown above &#8593;</button>'
            : '<button class="cqr-btn cqr-btn--solid" type="button" data-anchorpick="'+esc(c.handle)+'">Make this my system</button>'+
              '<a class="cqr-btn cqr-btn--ghost" href="'+urlFor(c.handle,c.url)+'" target="_blank" rel="noopener">View details</a>')+'</div></article>';
      }).join("")+'</section>';
  }

  /* ---- conditional stages: watch flags mapped to their systems, held for a test ---- */
  var flagsNow = watchFlags(b.seen||{});
  var COND_MAP = { nitrate:"nitrate-whole-house-water-filter", tannins:"tannin-whole-house-water-filter",
                   lead:"lead-removal-whole-house-water-filter", arsenic:"arsenic-whole-house-water-filter" };
  var coreHandles = items.map(function(it){ return it.handle; });
  var conds=[], condSeen={};
  flagsNow.forEach(function(f){
    var h=f.cid && COND_MAP[f.cid];
    if(!h || condSeen[h] || coreHandles.indexOf(h)>-1) return;
    var r=regRow(h); if(!r) return;
    condSeen[h]=1; conds.push({handle:h, name:r.name||h, url:r.url, flag:f.label, cid:f.cid});
  });
  if(S.surround.indexOf("septic")>-1 && !b.ctx.coliform){
    var uvr=regRow("ultraviolet-water-sterilizer-system");
    if(uvr && coreHandles.indexOf(uvr.handle)<0 && !condSeen[uvr.handle]){
      condSeen[uvr.handle]=1; conds.push({handle:uvr.handle, name:uvr.name, url:uvr.url, flag:"Bacteria (septic proximity)", cid:"bacteria"});
    }
  }
  conds=conds.slice(0,3);
  /* 2026-08-02: feed the email-capture payload; LAST.res/b/flags were
     declared but never assigned, so every lead submitted "No auto
     recommendation" with an empty profile */
  LAST.res=res; LAST.b=b; LAST.flags=flagsNow;

  /* ---- COMPLETE THIS SETUP (AJ 2026-07-29): companion cards in INSTALL
     order, then the test-first conditionals as dashed cards - one stage each,
     no price, no purchase CTA (the no-purchase-implication ruling holds) ---- */
  var setupHtml = "";
  if(comps.length || conds.length){
    var iOrder = items.map(function(it){ return it.handle; });
    var orderedComps = comps.slice().sort(function(a,b2){
      var ia=iOrder.indexOf(a.handle), ib=iOrder.indexOf(b2.handle);
      return (ia<0?99:ia)-(ib<0?99:ib);
    });
    var setupCards = orderedComps.map(function(c){
      /* the label must match the copy: contaminant hits are "flagged",
         treatment stages (dosing, UV, pre-treatment) are "recommended",
         proactive suggestions ("Hardness is not on this record") are
         "worth adding" */
      var lbl=/flagged/i.test(c.why||"") ? "Also flagged in your water"
        : (/risk|oxidiz|disinfect|dosing|needs carbon|pre-treatment|protects them/i.test(c.why||"") ? "Recommended stage" : "Worth adding");
      return '<article class="cqr-card"><p class="cqr-tierlabel">'+lbl+'</p>'+
        '<div class="cqr-plate">'+(imgFor(c.handle)?'<img loading="lazy" src="'+imgFor(c.handle)+'" alt="'+esc(c.name)+'">':'')+'</div>'+
        '<h3 class="cqr-name">'+esc(c.name)+'</h3>'+priceSlot(c.handle)+
        '<ul class="cqr-why"><li>'+(c.why||"")+'</li></ul>'+
        '<label class="cqr-check"><input type="checkbox" data-bcheck="'+esc(c.handle)+'" data-bkind="off"'+(stageOff(c.handle)?'':' checked')+'> In my build</label>'+
        '<div class="cqr-actions"><a class="cqr-btn cqr-btn--ghost" data-vh="'+esc(c.handle)+'" href="'+urlFor(c.handle,c.url)+'" target="_blank" rel="noopener">Choose options</a></div></article>';
    }).join("");
    var condCards = conds.map(function(c){
      var kit = kitFor(c.cid);
      /* AJ 2026-08-03: softened test-first close - priced, purchasable from
         its page, the test still leads */
      return '<article class="cqr-card cqr-card--maybe"><p class="cqr-tierlabel">Worth testing first</p>'+
        '<div class="cqr-plate">'+(imgFor(c.handle)?'<img loading="lazy" src="'+imgFor(c.handle)+'" alt="'+esc(c.name)+'">':'')+'</div>'+
        '<h3 class="cqr-name">'+esc(c.name)+'</h3>'+priceSlot(c.handle)+
        '<ul class="cqr-why"><li>Based on what you told us ('+esc(c.flag)+'), this is the stage we would expect to need. A quick test confirms it before you spend; add it now if you would rather have it handled.</li></ul>'+
        '<label class="cqr-check"><input type="checkbox" data-bcheck="'+esc(c.handle)+'" data-bkind="add"'+(stageAdded(c.handle)?' checked':'')+'> Add to my build</label>'+
        '<div class="cqr-actions"><a class="cqr-btn cqr-btn--ghost" href="'+kit.url+'" target="_blank" rel="noopener">Get the '+esc(kit.name)+'</a>'+
        '<a class="cqr-btn cqr-btn--ghost" data-vh="'+esc(c.handle)+'" href="'+urlFor(c.handle,c.url)+'" target="_blank" rel="noopener">View this system</a>'+
        '</div></article>';
    }).join("");
    var nSetup = orderedComps.length + conds.length;
    /* AJ 2026-08-03: a lone setup card centers at card width instead of
       sitting as an off-balance stray in a 3-column grid */
    setupHtml = '<p class="cqr-sub'+(nSetup===1?' cqr-sub--c':'')+'">Complete this setup</p>'+
      '<p class="cqr-subnote'+(nSetup===1?' cqr-subnote--c':'')+'">Supporting stages for what your answers flagged. Anything checked is in your build and the total below; uncheck what you want to skip.</p>'+
      '<section class="cqr-tiers'+(nSetup>1?' cqr-tiers--snap':' cqr-tiers--single')+'">'+setupCards+condCards+'</section>';
  }

  var tEl=document.getElementById("cqr-tiers");
  tEl.setAttribute("class","");
  tEl.innerHTML = heroHtml + compHtml + famHtml + trustHtml + setupHtml;
  /* swap-aware: the band total must price the anchor actually shown (High
     Flow when sizing swapped it), not the tank the engine emitted */
  LAST.setupHandles = coreHandles.map(function(h){
    return (h===res.primary.handle && anchor.handle!==res.primary.handle) ? anchor.handle : h;
  });
  LAST.condHandles = conds.map(function(c){ return c.handle; });
  LAST.anchorIsRo = anchor.handle==="whole-house-reverse-osmosis-system";
  LAST.cfg = (res.config && !cfgDup) ? {anchor:anchor.handle, kind:res.config.kind, fallback:res.config.handle} : null;
  /* drawer copy per stage (off/added were reset at the TOP of showResult,
     before any card rendered - opus verify D1) */
  LAST.stageInfo = {};
  seq.forEach(function(it, ix){
    var src = (it.handle===anchor.handle) ? anchor
      : (res.config && it.handle===res.config.handle) ? res.config
      : (comps.filter(function(cc){ return cc.handle===it.handle; })[0] || {});
    LAST.stageInfo[it.handle] = {
      name: it.name,
      img: imgFor(it.handle),
      url: urlFor(it.handle, src.url),
      why: src.why || (it.handle===anchor.handle ? (anchor.why||"") : ""),
      tag: it.tag ? "configuration of your system" : (ix===0 ? "point of entry" : "stage "+(ix+1)),
      cfg: it.price==="cfg",
      anchor: it.handle===anchor.handle
    };
  });
  /* AJ 2026-08-03 (later same day): the optional-additions row was tried and
     RETIRED - the editor is remove + read-more only. LAST.addable stays an
     empty list so the totals/cart machinery no-ops. Test-to-confirm stages
     get drawer copy + a purchase path (softened test-first framing). */
  /* conds are CHECKABLE (AJ 2026-08-03): checking one adds it to the build,
     totals and cart via the added-stage machinery; test-first framing stays */
  LAST.addable=[];
  conds.forEach(function(c){
    LAST.addable.push({handle:c.handle, name:c.name});
    LAST.stageInfo[c.handle]={ name:c.name, img:imgFor(c.handle), url:urlFor(c.handle, c.url),
      why:"Based on what you told us ("+c.flag+"), this is the stage we would expect to need."+
          " A quick test confirms it before you spend; if you would rather have it handled now,"+
          " add it to your build right here.",
      tag:"worth testing first", cfg:false, anchor:false, cond:true, kit:kitFor(c.cid) };
  });
  document.getElementById("cqr-band").innerHTML =
    '<p class="cqr-band-eyebrow">Your setup, stage by stage</p>'+
    '<h2 class="cqr-band-h">'+esc((res.ideal&&res.ideal.title)||"The complete Crystal Quest setup")+'</h2>'+
    '<p class="cqr-band-p">Installed in this order, each stage protecting the one after it. Adjust your build right here: tap a stage for details, or remove one with its &#215;.</p>'+
    '<div class="cqr-stack">'+seq.map(function(it,ix){
      /* every chip opens its BASE product page; the config chip prices as
         the add-on's in-bundle cost (AJ 2026-08-03) */
      var priceAttr = it.price==="cfg"
        ? ' data-price-handle="'+esc(anchor.handle)+'" data-price-cfg="'+esc(res.config.kind)+'" data-price-fallback="'+esc(it.handle)+'"'
        : ' data-price-handle="'+esc(it.handle)+'"';
      /* chip = on-screen drawer; the x edits the build in place */
      return (ix?'<span class="cqr-plus">+</span>':'')+
        '<span class="cqr-chipwrap">'+
        '<a class="cqr-stage2" data-stage="'+esc(it.handle)+'"'+(it.price==="cfg"?' data-cfgstage="1"':'')+' href="'+esc(urlFor(it.handle))+'" target="_blank" rel="noopener">'+(imgFor(it.handle)?'<img src="'+imgFor(it.handle)+'" alt="">':'')+
        '<span>'+esc(it.name)+'<small>'+(it.tag?it.tag:(ix===0?"point of entry":"stage "+(ix+1)))+'</small>'+
        (it.price?'<span'+priceAttr+' data-price-mini="1"></span>':'')+
        '</span></a>'+
        (it.handle!==anchor.handle?'<button class="cqr-chipx" type="button" data-chipx="'+esc(it.handle)+'" aria-label="Remove '+esc(it.name)+' from this build" title="Remove from build">&#215;</button>':'')+
        '</span>';
    }).join("")+
    '</div>'+
    (conds.length?'<p class="cqr-band-eyebrow" style="margin-top:20px">Possible additions &middot; worth testing first</p><div class="cqr-stack">'+
      conds.map(function(c){
        return '<a class="cqr-stage2 cqr-stage2--maybe" data-stage="'+esc(c.handle)+'" href="'+esc(urlFor(c.handle,c.url))+'" target="_blank" rel="noopener">'+(imgFor(c.handle)?'<img src="'+imgFor(c.handle)+'" alt="">':'')+
    ((S.buildMode==="ro" || anchor.handle!=="whole-house-reverse-osmosis-system")
      ?'<div class="cqr-bmode" role="group" aria-label="Build style">'+
       '<button type="button" class="cqr-bmode-btn'+(S.buildMode==="ro"?'':' is-on')+'" data-bmode="media">Recommended build</button>'+
       '<button type="button" class="cqr-bmode-btn'+(S.buildMode==="ro"?' is-on':'')+'" data-bmode="ro">Maximum purity (RO)</button>'+
       '</div>'+(S.buildMode==="ro"?'<p class="cqr-bmode-sub">One whole-house reverse osmosis system covering this entire profile'+(seq.length>1?', with the pre-treatment it needs':'')+'. Flip back any time to compare.</p>':'')
      :'')+
          '<span>'+esc(c.name)+'<small>test to confirm: '+esc(c.flag)+'</small>'+
          '<span data-price-handle="'+esc(c.handle)+'" data-price-mini="1"></span></span></a>';
      }).join("")+'</div>':'')+
    '<div class="cqr-bandbuy"><span id="cqr-btotal"></span></div>'+
    (conds.length?'<div class="cqr-bandbuy" style="margin-top:8px"><span id="cqr-ctotal"></span></div>':'')+
    '<div id="cqr-crossover"></div>'+
    '<div class="cqr-bandbuy" style="margin-top:12px">'+
    (CART_HOST?'<button class="cqr-bandbtn" id="cqr-addbuild" type="button" hidden>Add this build to cart</button>':'')+
    '<a class="cqr-bandbtn" data-vh="'+esc(anchor.handle)+'" style="text-decoration:none" href="'+anchor.url+'" target="_blank" rel="noopener">Configure this system</a>'+
    '<a class="cqr-bandbtn cqr-bandbtn--ghost" style="text-decoration:none" href="https://crystalquest.com/pages/contact-us" target="_blank" rel="noopener">Talk to a specialist about this build</a>'+
    '<span class="cqr-bandnote">Live crystalquest.com prices, for the systems themselves; standard plumbing installation is arranged separately. Where a pairing exists as one combined system, the total already uses that bundled price. '+(anchor.handle==="whole-house-reverse-osmosis-system"?'Ownership: RO sends a reject stream to drain; the membrane swaps every 2 to 4 years and filters every 12 to 24 months.':'Ownership: main media beds last 5 to 10 years; included cartridges swap on a 6 to 24 month cadence.')+'</span></div>'+
    (res.pou?'<p class="cqr-polish">Optional drinking-water polish: <a href="'+urlFor(res.pou.handle,res.pou.url)+'" target="_blank" rel="noopener">'+esc(res.pou.name)+'</a> at the kitchen tap'+
      (res.pou_alt?', or the <a href="'+urlFor(res.pou_alt.handle,res.pou_alt.url)+'" target="_blank" rel="noopener">'+esc(res.pou_alt.name)+'</a> if you prefer no membrane or drain line':'')+'.</p>':'');
  LAST.rationaleHtml = buildRationale(res, b, anchor, sizeLine, sizeNote, conds, seq);

  renderFlags(b);

  finishResult(res, anchor, sizeLine);
}
function finishResult(res, anchor, sizeLine){
  var notes = (res && res.notes) || [];
  var host = document.getElementById("cqr-notes");
  /* AJ 2026-08-03: the standalone well test-first section is GONE - test
     talk now lives only in the bottom refine row, beside the report card */
  if(host) host.innerHTML = (LAST.rationaleHtml||"") + (notes.length
    ? '<div style="margin-top:18px">'+notes.map(function(n){return '<p class="cqr-note">'+n+'</p>';}).join("")+'</div>' : "");
  LAST.sizeLine = sizeLine || "";
  LAST.roSize = (res && res.sizing && (res.sizing.ro || res.sizing.ro_alt)) || "";
  /* re-render the top toggles now that this render's LAST state exists -
     the early call in showResult read the PREVIOUS render's state */
  renderScopeToggle();
  /* soften the re-render: the swapped regions fade in rather than snapping */
  ["cqr-tiers","cqr-band","cqr-notes","cqr-flags"].forEach(function(fid){
    var fel=document.getElementById(fid); if(!fel) return;
    fel.classList.remove("cqr-fadein"); void fel.offsetWidth; fel.classList.add("cqr-fadein");
  });
  if(res && res.primary){
    var a = anchor || res.primary;
    document.getElementById("cqr-sname").textContent = a.name;
    document.getElementById("cqr-ssub").innerHTML = esc(sizeLine||"")+' &middot; <span data-price-handle="'+esc(a.handle)+'" data-price-mini="1"></span>';
    var sbtn=document.querySelector("#cqr-sticky .cqr-sticky-btn");
    if(sbtn){ sbtn.textContent="Configure"; sbtn.onclick=function(){ window.open(a.url||"#","_blank"); }; }
  }
  var dEl=document.getElementById("cqr-diff");
  if(dEl){
    if(res && DIFFCTX){
      var added=(LAST.cids||[]).filter(function(c){ return DIFFCTX.cids.indexOf(c)<0; });
      var srcLabel = DIFFCTX.src==="zip" ? "area&#39;s public records" : "water report";
      var names=added.slice(0,3).map(prettyCid).map(esc).join(", ");
      var msg;
      if(DIFFCTX.anchor && LAST.anchorName && DIFFCTX.anchor!==LAST.anchorName){
        msg='Result updated: <b>'+esc(DIFFCTX.anchor)+'</b> was replaced by <b>'+esc(LAST.anchorName)+'</b> because your '+srcLabel+(added.length?' added '+names+(added.length>3?'&hellip;':''):' changed the picture')+'.';
      } else if(added.length){
        msg='Result updated: your '+srcLabel+' added <b>'+added.length+' factor'+(added.length>1?'s':'')+'</b> ('+names+(added.length>3?'&hellip;':'')+'). The recommendation held.';
      } else {
        msg='Result re-checked against your '+srcLabel+': nothing new changed the picture.';
      }
      dEl.innerHTML='<div class="cqr-strip">'+msg+'</div>';
    } else {
      dEl.innerHTML="";
    }
    DIFFCTX=null;
  }
  renderRefine();
  var rtEl=document.getElementById("cqr-rt"); if(rtEl) rtEl.hidden=true;
  document.getElementById("cqw-shell").hidden=true;
  unlockBody();
  document.getElementById("cqr-root").hidden=false;
  STICKY_OK=!!(res&&res.primary);
  updateSticky();
  paintPrices();
  if(KEEP_SCROLL_Y!=null){ window.scrollTo(0,KEEP_SCROLL_Y); KEEP_SCROLL_Y=null; }
  else window.scrollTo(0,0);
}

/* ---- email capture: HubSpot Forms API (same live-tested form as the original quiz) ---- */
var CQ_HUBSPOT = { portalId: "243237512", formGuid: "15f66491-6726-4a0e-bdaa-f7c1703654c3", endpoint: "https://api-na2.hsforms.com" };
var LAST = { res:null, b:null, flags:[] };
/* 2026-08-02: the sticky buy bar earns its place only after the hero card's
   own buttons scroll out of view; before that it duplicates the CTA on the
   first screen and covers content on mobile */
var STICKY_OK=false;
var KEEP_SCROLL_Y=null;
function updateSticky(){
  var bar=document.getElementById("cqr-sticky");
  if(!bar) return;
  if(!STICKY_OK){ bar.hidden=true; return; }
  var hero=document.querySelector("#cqr-tiers .cqr-card--rec .cqr-actions");
  bar.hidden = hero ? hero.getBoundingClientRect().bottom>0 : false;
}
window.addEventListener("scroll", updateSticky, {passive:true});
window.addEventListener("resize", updateSticky);
/* print-off: free, ungated (email capture stays the lead path) */
(function(){
  var pb=document.getElementById("cqr-print");
  if(pb) pb.addEventListener("click", function(){ cqTrack("print_results",{}); window.print(); });
})();
document.getElementById("cqr-cap-btn").addEventListener("click", function(){
  var btn=this, box=document.getElementById("cqr-cap"), inp=document.getElementById("cqr-cap-email");
  var email=(inp.value||"").trim();
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
    inp.style.borderColor="#b91c1c";
    var er=document.getElementById("cqr-cap-err");
    if(!er){ er=document.createElement("p"); er.id="cqr-cap-err"; er.className="cqr-cap-err"; er.setAttribute("role","alert"); box.appendChild(er); }
    er.textContent="That email does not look complete. Check it and try again.";
    return;
  }
  inp.style.borderColor="";
  var er0=document.getElementById("cqr-cap-err"); if(er0) er0.parentNode.removeChild(er0);
  var res=LAST.res, flags=LAST.flags||[];
  /* AJ 2026-08-03: the CRM field carries the FULL quoted build so a rep
     opening the contact knows exactly what to talk about */
  var summary;
  if(res && res.primary){
    var stg=((res.ideal&&res.ideal.items)||[]).map(function(it){ return it.name; });
    summary = res.primary.name
      + (res.config ? " + " + res.config.name + " (configuration)" : "")
      + (stg.length>1 ? " | stages: " + stg.join(" -> ") : "")
      + (res.pou ? " | POU option: " + res.pou.name : "")
      + " | " + res.primary.url;
  } else {
    summary = "No auto recommendation, needs a water test";
  }
  btn.disabled=true; btn.textContent="Sending…";
  fetch(CQ_HUBSPOT.endpoint+"/submissions/v3/integration/submit/"+CQ_HUBSPOT.portalId+"/"+CQ_HUBSPOT.formGuid,{
    method:"POST", headers:{"Content-Type":"application/json"},
    body:JSON.stringify({
      fields:[{name:"email",value:email},
              {name:"water_quiz_recommendation",value:summary},
              {name:"water_quiz_zip",value:S.zip||""},
              {name:"water_quiz_source",value:S.source||""},
              {name:"water_quiz_needs_test",value:(flags && flags.length)?"true":"false"},
              {name:"water_quiz_profile",value:JSON.stringify({
                profile:(LAST.b&&LAST.b.profile)||[], scope:S.scope, notice:S.notice,
                surround:S.surround, concerns:S.concerns,
                people:S.people, baths:S.baths,
                watch:flags.map(function(w){return w.label;})
              }).slice(0,3000)}],
      context:{pageUri:location.href,pageName:document.title}
    })
  }).then(function(r){ if(!r.ok) throw new Error(r.status);
    box.innerHTML='<p class="cqr-cap-h">&#10003; On its way!</p><p class="cqr-cap-p">Your results and discount code are headed to <b>'+esc(email)+'</b>.</p>';
  }).catch(function(){
    btn.disabled=false; btn.textContent="Email my results";
    var note=document.getElementById("cqr-cap-note");
    if(!note){ note=document.createElement("p"); note.id="cqr-cap-note"; note.className="cqr-fine"; box.appendChild(note); }
    note.textContent="Couldn't reach our email service, try again in a minute.";
  });
});

document.getElementById("cqr-root").addEventListener("click", function(e){
  if(e.target.closest("[data-scrolltop]")){ window.scrollTo({top:0,behavior:"smooth"}); return; }
  if(e.target.closest("[data-restart2]")){ document.getElementById("cqr-restart").click(); return; }
  var cp=e.target.closest("[data-cfgpref]");
  if(cp){ var pv=cp.getAttribute("data-cfgpref");
    /* the toggle sits mid-page inside the config card: hold the reader's
       place through the re-render instead of throwing them to the top */
    if(S.configPref!==pv){ S.configPref=pv; KEEP_SCROLL_Y=window.scrollY; cqTrack("config_pref",{pick:pv}); showResult(); }
    return; }
  var sv=e.target.closest("[data-srcview]");
  if(sv){ var nsrc=sv.getAttribute("data-srcview");
    if(S.source!==nsrc){ S.source=nsrc; cqTrack("source_view",{src:nsrc}); showResult(); }
    return; }
  var tv=e.target.closest("[data-view]");
  if(tv){
    var nv=tv.getAttribute("data-view");
    if(S.view!==nv){ S.view=nv; cqTrack("scope_switched",{view:nv}); showResult(); }
    return;
  }
  var a=e.target.closest("a.cqr-btn,a.cqr-mini,a.cqr-ref-btn,a.cqr-bandbtn");
  if(a) cqTrack("cta_click",{kind:(a.className.match(/cqr-[a-z-]+/)||["link"])[0], primary:a.className.indexOf("solid")>-1});
});

document.getElementById("cqr-restart").addEventListener("click",function(){
  idx=0; QS.forEach(function(q){ if(q.kind) return; S[q.k]=q.multi?[]:null; });
  S.surround=[]; S.people=null; S.baths=null; S.demand=[]; S.view=null; S.wellchlor=null; S.configPref=null; S.buildMode=null; S.anchorPref=null; S._doneTracked=false;
  S.srcUnsure=undefined; S._moreOpen=undefined;
  S.zip=""; S.zipUtil=null; S.zipApprox=false; S.zipProfile=[];
  S.reportProfile=[]; S.reportChips=[]; S.reportNonDetects=[]; zipSeq++;
  document.getElementById("cqr-root").hidden=true;
  STICKY_OK=false;
  document.getElementById("cqr-sticky").hidden=true;
  if(MODE==="report"){
    var rtEl2=document.getElementById("cqr-rt"); if(rtEl2) rtEl2.hidden=false;
    var po=document.getElementById("cqr-parseout"); if(po) po.innerHTML="";
    var pa=document.getElementById("cqr-paste"); if(pa) pa.value="";
    window.scrollTo(0,0);
    return;
  }
  document.getElementById("cqw-shell").hidden=false;
  lockBody();
  render();
});

if(MODE==="report"){
  document.getElementById("cqw-shell").hidden=true;
  unlockBody();
  var rtBoot=document.getElementById("cqr-rt");
  rtBoot.hidden=false;
  S.scope="unsure"; if(!S.source) S.source="city";
  document.title="Water Report Analyzer | Crystal Quest";
  cqTrack("report_tool_open",{});
  [].forEach.call(document.querySelectorAll("[data-rtsrc]"),function(btn){
    btn.addEventListener("click",function(){
      S.source=btn.getAttribute("data-rtsrc");
      [].forEach.call(document.querySelectorAll("[data-rtsrc]"),function(o){ o.classList.toggle("is-on", o===btn); });
    });
  });
  if(S.source==="well"){
    [].forEach.call(document.querySelectorAll("[data-rtsrc]"),function(o){ o.classList.toggle("is-on", o.getAttribute("data-rtsrc")==="well"); });
  }
  var rtDrop=document.getElementById("cqr-drop"), rtFile=document.getElementById("cqr-file");
  rtDrop.addEventListener("click",function(){ rtFile.click(); });
  rtFile.addEventListener("click",function(e){ e.stopPropagation(); });
  ["dragover","dragenter"].forEach(function(ev){ rtDrop.addEventListener(ev,function(e){ e.preventDefault(); rtDrop.classList.add("is-over"); }); });
  ["dragleave","drop"].forEach(function(ev){ rtDrop.addEventListener(ev,function(e){ e.preventDefault(); rtDrop.classList.remove("is-over"); }); });
  rtDrop.addEventListener("drop",function(e){ readReportFile(e.dataTransfer.files[0]); });
  rtFile.addEventListener("change",function(){ readReportFile(rtFile.files[0]); });
  document.getElementById("cqr-pbtn").addEventListener("click",function(){
    var t=(document.getElementById("cqr-paste").value||"");
    if(!t.trim()){ setParseOut("<div class='cqr-refnote'>Paste some results (or upload a file) first.</div>"); return; }
    parseReport(t).then(afterParse);
  });
} else {
  var rtGone=document.getElementById("cqr-rt");
  if(rtGone) rtGone.parentNode.removeChild(rtGone);
  lockBody();
  render();
}
})();
